var items = {
  "block.minecraft.acacia_button": "Akasieknapp",
  "block.minecraft.acacia_door": "Akasiedør",
  "block.minecraft.acacia_fence": "Akasiegjerde",
  "block.minecraft.acacia_fence_gate": "Akasiegrind",
  "block.minecraft.acacia_hanging_sign": "Hengende akasieskilt",
  "block.minecraft.acacia_leaves": "Akasieløv",
  "block.minecraft.acacia_log": "Akasietømmer",
  "block.minecraft.acacia_planks": "Akasieplanker",
  "block.minecraft.acacia_pressure_plate": "Akasietrykkplate",
  "block.minecraft.acacia_sapling": "Akasiespire",
  "block.minecraft.acacia_shelf": "Akasiehylle",
  "block.minecraft.acacia_sign": "Akasieskilt",
  "block.minecraft.acacia_slab": "Akasiehelle",
  "block.minecraft.acacia_stairs": "Akasietrapp",
  "block.minecraft.acacia_trapdoor": "Akasiefallem",
  "block.minecraft.acacia_wall_hanging_sign": "Vegghengende akasieskilt",
  "block.minecraft.acacia_wall_sign": "Akasieveggskilt",
  "block.minecraft.acacia_wood": "Akasietre",
  "block.minecraft.activator_rail": "Aktiveringsskinne",
  "block.minecraft.air": "Luft",
  "block.minecraft.allium": "Prydløk",
  "block.minecraft.amethyst_block": "Ametystblokk",
  "block.minecraft.amethyst_cluster": "Ametystklase",
  "block.minecraft.ancient_debris": "Eldgammelt skrap",
  "block.minecraft.andesite": "Andesitt",
  "block.minecraft.andesite_slab": "Helle av andesitt",
  "block.minecraft.andesite_stairs": "Trapp av andesitt",
  "block.minecraft.andesite_wall": "Mur av andesitt",
  "block.minecraft.anvil": "Ambolt",
  "block.minecraft.attached_melon_stem": "Tilknyttet melonstilk",
  "block.minecraft.attached_pumpkin_stem": "Festet gresskarstilk",
  "block.minecraft.azalea": "Asalea",
  "block.minecraft.azalea_leaves": "Asaleablader",
  "block.minecraft.azure_bluet": "Houstonia caerulea",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambusblokk",
  "block.minecraft.bamboo_button": "Bambusknapp",
  "block.minecraft.bamboo_door": "Bambusdør",
  "block.minecraft.bamboo_fence": "Bambusgjerde",
  "block.minecraft.bamboo_fence_gate": "Bambusgrind",
  "block.minecraft.bamboo_hanging_sign": "Hengende bambusskilt",
  "block.minecraft.bamboo_mosaic": "Bambusmosaikk",
  "block.minecraft.bamboo_mosaic_slab": "Bambusmosaikkhelle",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusmosaikktrapp",
  "block.minecraft.bamboo_planks": "Bambusplanker",
  "block.minecraft.bamboo_pressure_plate": "Bambustrykkplate",
  "block.minecraft.bamboo_sapling": "Bambusskudd",
  "block.minecraft.bamboo_shelf": "Bambushylle",
  "block.minecraft.bamboo_sign": "Bambusskilt",
  "block.minecraft.bamboo_slab": "Bambushelle",
  "block.minecraft.bamboo_stairs": "Bambustrapp",
  "block.minecraft.bamboo_trapdoor": "Bambusfallem",
  "block.minecraft.bamboo_wall_hanging_sign": "Vegghengende bambusskilt",
  "block.minecraft.bamboo_wall_sign": "Bambusveggskilt",
  "block.minecraft.banner.base.black": "Svart bunn",
  "block.minecraft.banner.base.blue": "Blå bunn",
  "block.minecraft.banner.base.brown": "Brun bunn",
  "block.minecraft.banner.base.cyan": "Turkis bunn",
  "block.minecraft.banner.base.gray": "Grå bunn",
  "block.minecraft.banner.base.green": "Grønn bunn",
  "block.minecraft.banner.base.light_blue": "Lyseblå bunn",
  "block.minecraft.banner.base.light_gray": "Lysegrå bunn",
  "block.minecraft.banner.base.lime": "Limegrønn bunn",
  "block.minecraft.banner.base.magenta": "Magenta bunn",
  "block.minecraft.banner.base.orange": "Oransje bunn",
  "block.minecraft.banner.base.pink": "Rosa bunn",
  "block.minecraft.banner.base.purple": "Lilla bunn",
  "block.minecraft.banner.base.red": "Rød bunn",
  "block.minecraft.banner.base.white": "Hvit bunn",
  "block.minecraft.banner.base.yellow": "Gul bunn",
  "block.minecraft.banner.border.black": "Svart bord",
  "block.minecraft.banner.border.blue": "Blått bord",
  "block.minecraft.banner.border.brown": "Brunt bord",
  "block.minecraft.banner.border.cyan": "Turkist bord",
  "block.minecraft.banner.border.gray": "Grått bord",
  "block.minecraft.banner.border.green": "Grønt bord",
  "block.minecraft.banner.border.light_blue": "Lyseblått bord",
  "block.minecraft.banner.border.light_gray": "Lysegrått bord",
  "block.minecraft.banner.border.lime": "Limegrønt bord",
  "block.minecraft.banner.border.magenta": "Magenta bord",
  "block.minecraft.banner.border.orange": "Oransje bord",
  "block.minecraft.banner.border.pink": "Rosa bord",
  "block.minecraft.banner.border.purple": "Lilla bord",
  "block.minecraft.banner.border.red": "Rødt bord",
  "block.minecraft.banner.border.white": "Hvitt bord",
  "block.minecraft.banner.border.yellow": "Gult bord",
  "block.minecraft.banner.bricks.black": "Svart mursteinmønster",
  "block.minecraft.banner.bricks.blue": "Blått mursteinmønster",
  "block.minecraft.banner.bricks.brown": "Brunt mursteinmønster",
  "block.minecraft.banner.bricks.cyan": "Turkist mursteinmønster",
  "block.minecraft.banner.bricks.gray": "Grått mursteinmønster",
  "block.minecraft.banner.bricks.green": "Grønt mursteinmønster",
  "block.minecraft.banner.bricks.light_blue": "Lyseblått mursteinmønster",
  "block.minecraft.banner.bricks.light_gray": "Lysegrått mursteinmønster",
  "block.minecraft.banner.bricks.lime": "Limegrønt mursteinmønster",
  "block.minecraft.banner.bricks.magenta": "Magenta mursteinmønster",
  "block.minecraft.banner.bricks.orange": "Oransje mursteinmønster",
  "block.minecraft.banner.bricks.pink": "Rosa mursteinmønster",
  "block.minecraft.banner.bricks.purple": "Lilla mursteinmønster",
  "block.minecraft.banner.bricks.red": "Rødt mursteinmønster",
  "block.minecraft.banner.bricks.white": "Hvitt mursteinmønster",
  "block.minecraft.banner.bricks.yellow": "Gult mursteinmønster",
  "block.minecraft.banner.circle.black": "Svart skive",
  "block.minecraft.banner.circle.blue": "Blå skive",
  "block.minecraft.banner.circle.brown": "Brun skive",
  "block.minecraft.banner.circle.cyan": "Turkis skive",
  "block.minecraft.banner.circle.gray": "Grå skive",
  "block.minecraft.banner.circle.green": "Grønn skive",
  "block.minecraft.banner.circle.light_blue": "Lyseblå skive",
  "block.minecraft.banner.circle.light_gray": "Lysegrå skive",
  "block.minecraft.banner.circle.lime": "Limegrønn skive",
  "block.minecraft.banner.circle.magenta": "Magenta skive",
  "block.minecraft.banner.circle.orange": "Oransje skive",
  "block.minecraft.banner.circle.pink": "Rosa skive",
  "block.minecraft.banner.circle.purple": "Lilla skive",
  "block.minecraft.banner.circle.red": "Rød skive",
  "block.minecraft.banner.circle.white": "Hvit skive",
  "block.minecraft.banner.circle.yellow": "Gul skive",
  "block.minecraft.banner.creeper.black": "Svart creeper",
  "block.minecraft.banner.creeper.blue": "Blå creeper",
  "block.minecraft.banner.creeper.brown": "Brun creeper",
  "block.minecraft.banner.creeper.cyan": "Turkis creeper",
  "block.minecraft.banner.creeper.gray": "Grå creeper",
  "block.minecraft.banner.creeper.green": "Grønn creeper",
  "block.minecraft.banner.creeper.light_blue": "Lyseblå creeper",
  "block.minecraft.banner.creeper.light_gray": "Lysegrå creeper",
  "block.minecraft.banner.creeper.lime": "Limegrønn creeper",
  "block.minecraft.banner.creeper.magenta": "Magenta creeper",
  "block.minecraft.banner.creeper.orange": "Oransje creeper",
  "block.minecraft.banner.creeper.pink": "Rosa creeper",
  "block.minecraft.banner.creeper.purple": "Lilla creeper",
  "block.minecraft.banner.creeper.red": "Rød creeper",
  "block.minecraft.banner.creeper.white": "Hvit creeper",
  "block.minecraft.banner.creeper.yellow": "Gul creeper",
  "block.minecraft.banner.cross.black": "Svart andreaskors",
  "block.minecraft.banner.cross.blue": "Blått andreaskors",
  "block.minecraft.banner.cross.brown": "Brunt andreaskors",
  "block.minecraft.banner.cross.cyan": "Turkist andreaskors",
  "block.minecraft.banner.cross.gray": "Grått andreaskors",
  "block.minecraft.banner.cross.green": "Grønt andreaskors",
  "block.minecraft.banner.cross.light_blue": "Lyseblått andreaskors",
  "block.minecraft.banner.cross.light_gray": "Lysegrått andreaskors",
  "block.minecraft.banner.cross.lime": "Limegrønt andreaskors",
  "block.minecraft.banner.cross.magenta": "Magenta andreaskors",
  "block.minecraft.banner.cross.orange": "Oransje andreaskors",
  "block.minecraft.banner.cross.pink": "Rosa andreaskors",
  "block.minecraft.banner.cross.purple": "Lilla andreaskors",
  "block.minecraft.banner.cross.red": "Rødt andreaskors",
  "block.minecraft.banner.cross.white": "Hvitt andreaskors",
  "block.minecraft.banner.cross.yellow": "Gult andreaskors",
  "block.minecraft.banner.curly_border.black": "Svart bord med tannsnitt",
  "block.minecraft.banner.curly_border.blue": "Blått bord med tannsnitt",
  "block.minecraft.banner.curly_border.brown": "Brunt bord med tannsnitt",
  "block.minecraft.banner.curly_border.cyan": "Turkist bord med tannsnitt",
  "block.minecraft.banner.curly_border.gray": "Grått bord med tannsnitt",
  "block.minecraft.banner.curly_border.green": "Grønt bord med tannsnitt",
  "block.minecraft.banner.curly_border.light_blue": "Lyseblått bord med tannsnitt",
  "block.minecraft.banner.curly_border.light_gray": "Lysegrått bord med tannsnitt",
  "block.minecraft.banner.curly_border.lime": "Limegrønt bord med tannsnitt",
  "block.minecraft.banner.curly_border.magenta": "Magenta bord med tannsnitt",
  "block.minecraft.banner.curly_border.orange": "Oransje bord med tannsnitt",
  "block.minecraft.banner.curly_border.pink": "Rosa bord med tannsnitt",
  "block.minecraft.banner.curly_border.purple": "Lilla bord med tannsnitt",
  "block.minecraft.banner.curly_border.red": "Rødt bord med tannsnitt",
  "block.minecraft.banner.curly_border.white": "Hvitt bord med tannsnitt",
  "block.minecraft.banner.curly_border.yellow": "Gult bord med tannsnitt",
  "block.minecraft.banner.diagonal_left.black": "Svart venstreskrådeling",
  "block.minecraft.banner.diagonal_left.blue": "Blå venstreskrådeling",
  "block.minecraft.banner.diagonal_left.brown": "Brun venstreskrådeling",
  "block.minecraft.banner.diagonal_left.cyan": "Turkis venstreskrådeling",
  "block.minecraft.banner.diagonal_left.gray": "Grå venstreskrådeling",
  "block.minecraft.banner.diagonal_left.green": "Grønn venstreskrådeling",
  "block.minecraft.banner.diagonal_left.light_blue": "Lyseblå venstreskrådeling",
  "block.minecraft.banner.diagonal_left.light_gray": "Lysegrå venstreskrådeling",
  "block.minecraft.banner.diagonal_left.lime": "Limegrønn venstreskrådeling",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta venstreskrådeling",
  "block.minecraft.banner.diagonal_left.orange": "Oransje venstreskrådeling",
  "block.minecraft.banner.diagonal_left.pink": "Rosa venstreskrådeling",
  "block.minecraft.banner.diagonal_left.purple": "Lilla venstreskrådeling",
  "block.minecraft.banner.diagonal_left.red": "Rød venstreskrådeling",
  "block.minecraft.banner.diagonal_left.white": "Hvit venstreskrådeling",
  "block.minecraft.banner.diagonal_left.yellow": "Gul venstreskrådeling",
  "block.minecraft.banner.diagonal_right.black": "Svart skrådeling",
  "block.minecraft.banner.diagonal_right.blue": "Blå skrådeling",
  "block.minecraft.banner.diagonal_right.brown": "Brun skrådeling",
  "block.minecraft.banner.diagonal_right.cyan": "Turkis skrådeling",
  "block.minecraft.banner.diagonal_right.gray": "Grå skrådeling",
  "block.minecraft.banner.diagonal_right.green": "Grønn skrådeling",
  "block.minecraft.banner.diagonal_right.light_blue": "Lyseblå skrådeling",
  "block.minecraft.banner.diagonal_right.light_gray": "Lysegrå skrådeling",
  "block.minecraft.banner.diagonal_right.lime": "Limegrønn skrådeling",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta skrådeling",
  "block.minecraft.banner.diagonal_right.orange": "Oransje skrådeling",
  "block.minecraft.banner.diagonal_right.pink": "Rosa skrådeling",
  "block.minecraft.banner.diagonal_right.purple": "Lilla skrådeling",
  "block.minecraft.banner.diagonal_right.red": "Rød skrådeling",
  "block.minecraft.banner.diagonal_right.white": "Hvit skrådeling",
  "block.minecraft.banner.diagonal_right.yellow": "Gul skrådeling",
  "block.minecraft.banner.diagonal_up_left.black": "Svart skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.blue": "Blå skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.brown": "Brun skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.cyan": "Turkis skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.gray": "Grå skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.green": "Grønn skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Lyseblå skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Lysegrå skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.lime": "Limegrønn omvendt skrådeling",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.orange": "Oransje skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.pink": "Rosa skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.purple": "Lilla skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.red": "Rød skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.white": "Hvit skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gul skrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.black": "Svart venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.blue": "Blå venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.brown": "Brun venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.cyan": "Turkis venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.gray": "Grå venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.green": "Grønn venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Lyseblå venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Lysegrå venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.lime": "Limegrønn omvendt venstreskrådeling",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.orange": "Oransje venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.pink": "Rosa venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.purple": "Lilla venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.red": "Rød venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.white": "Hvit venstreskrådeling (omvendt)",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gul venstreskrådeling (omvendt)",
  "block.minecraft.banner.flow.black": "Svart virvel",
  "block.minecraft.banner.flow.blue": "Blå virvel",
  "block.minecraft.banner.flow.brown": "Brun virvel",
  "block.minecraft.banner.flow.cyan": "Cyan virvel",
  "block.minecraft.banner.flow.gray": "Grå virvel",
  "block.minecraft.banner.flow.green": "Grønn virvel",
  "block.minecraft.banner.flow.light_blue": "Lyseblå virvel",
  "block.minecraft.banner.flow.light_gray": "Lysegrå virvel",
  "block.minecraft.banner.flow.lime": "Limegrønn virvel",
  "block.minecraft.banner.flow.magenta": "Magenta virvel",
  "block.minecraft.banner.flow.orange": "Oransje virvel",
  "block.minecraft.banner.flow.pink": "Rosa virvel",
  "block.minecraft.banner.flow.purple": "Lilla virvel",
  "block.minecraft.banner.flow.red": "Rød virvel",
  "block.minecraft.banner.flow.white": "Hvit virvel",
  "block.minecraft.banner.flow.yellow": "Gul virvel",
  "block.minecraft.banner.flower.black": "Svart blomst",
  "block.minecraft.banner.flower.blue": "Blå blomst",
  "block.minecraft.banner.flower.brown": "Brun blomst",
  "block.minecraft.banner.flower.cyan": "Turkis blomst",
  "block.minecraft.banner.flower.gray": "Grå blomst",
  "block.minecraft.banner.flower.green": "Grønn blomst",
  "block.minecraft.banner.flower.light_blue": "Lyseblå blomst",
  "block.minecraft.banner.flower.light_gray": "Lysegrå blomst",
  "block.minecraft.banner.flower.lime": "Limegrønn blomst",
  "block.minecraft.banner.flower.magenta": "Magenta blomst",
  "block.minecraft.banner.flower.orange": "Oransje blomst",
  "block.minecraft.banner.flower.pink": "Rosa blomst",
  "block.minecraft.banner.flower.purple": "Lilla blomst",
  "block.minecraft.banner.flower.red": "Rød blomst",
  "block.minecraft.banner.flower.white": "Hvit blomst",
  "block.minecraft.banner.flower.yellow": "Gul blomst",
  "block.minecraft.banner.globe.black": "Svart globus",
  "block.minecraft.banner.globe.blue": "Blå globus",
  "block.minecraft.banner.globe.brown": "Brun globus",
  "block.minecraft.banner.globe.cyan": "Turkis globus",
  "block.minecraft.banner.globe.gray": "Grå globus",
  "block.minecraft.banner.globe.green": "Grønn globus",
  "block.minecraft.banner.globe.light_blue": "Lyseblå globus",
  "block.minecraft.banner.globe.light_gray": "Lysegrå globus",
  "block.minecraft.banner.globe.lime": "Limegrønn globus",
  "block.minecraft.banner.globe.magenta": "Magenta globus",
  "block.minecraft.banner.globe.orange": "Oransje globus",
  "block.minecraft.banner.globe.pink": "Rosa globus",
  "block.minecraft.banner.globe.purple": "Lilla globus",
  "block.minecraft.banner.globe.red": "Rød globus",
  "block.minecraft.banner.globe.white": "Hvit globus",
  "block.minecraft.banner.globe.yellow": "Gul globus",
  "block.minecraft.banner.gradient.black": "Svart overgang",
  "block.minecraft.banner.gradient.blue": "Blå overgang",
  "block.minecraft.banner.gradient.brown": "Brun overgang",
  "block.minecraft.banner.gradient.cyan": "Turkis overgang",
  "block.minecraft.banner.gradient.gray": "Grå overgang",
  "block.minecraft.banner.gradient.green": "Grønn overgang",
  "block.minecraft.banner.gradient.light_blue": "Lyseblå overgang",
  "block.minecraft.banner.gradient.light_gray": "Lysegrå overgang",
  "block.minecraft.banner.gradient.lime": "Limegrønn overgang",
  "block.minecraft.banner.gradient.magenta": "Magenta overgang",
  "block.minecraft.banner.gradient.orange": "Oransje overgang",
  "block.minecraft.banner.gradient.pink": "Rosa overgang",
  "block.minecraft.banner.gradient.purple": "Lilla overgang",
  "block.minecraft.banner.gradient.red": "Rød overgang",
  "block.minecraft.banner.gradient.white": "Hvit overgang",
  "block.minecraft.banner.gradient.yellow": "Gul overgang",
  "block.minecraft.banner.gradient_up.black": "Svart overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.blue": "Blå overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.brown": "Brun overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.cyan": "Turkis overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.gray": "Grå overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.green": "Grønn overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.light_blue": "Lyseblå overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.light_gray": "Lysegrå overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.lime": "Limegrønn overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.magenta": "Magenta overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.orange": "Oransje overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.pink": "Rosa overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.purple": "Lilla overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.red": "Rød overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.white": "Hvit overgang fra skjoldfoten",
  "block.minecraft.banner.gradient_up.yellow": "Gul overgang fra skjoldfoten",
  "block.minecraft.banner.guster.black": "Svart vindkaster",
  "block.minecraft.banner.guster.blue": "Blå vindkaster",
  "block.minecraft.banner.guster.brown": "Brun vindkaster",
  "block.minecraft.banner.guster.cyan": "Turkis vindkaster",
  "block.minecraft.banner.guster.gray": "Grå vindkaster",
  "block.minecraft.banner.guster.green": "Grønn vindkaster",
  "block.minecraft.banner.guster.light_blue": "Lyseblå vindkaster",
  "block.minecraft.banner.guster.light_gray": "Lysegrå vindkaster",
  "block.minecraft.banner.guster.lime": "Limegrønn vindkaster",
  "block.minecraft.banner.guster.magenta": "Magenta vindkaster",
  "block.minecraft.banner.guster.orange": "Oransje vindkaster",
  "block.minecraft.banner.guster.pink": "Rosa vindkaster",
  "block.minecraft.banner.guster.purple": "Lilla vindkaster",
  "block.minecraft.banner.guster.red": "Rød vindkaster",
  "block.minecraft.banner.guster.white": "Hvit vindkaster",
  "block.minecraft.banner.guster.yellow": "Gul vindkaster",
  "block.minecraft.banner.half_horizontal.black": "Svart overdel",
  "block.minecraft.banner.half_horizontal.blue": "Blå overdel",
  "block.minecraft.banner.half_horizontal.brown": "Brun overdel",
  "block.minecraft.banner.half_horizontal.cyan": "Turkis overdel",
  "block.minecraft.banner.half_horizontal.gray": "Grå overdel",
  "block.minecraft.banner.half_horizontal.green": "Grønn overdel",
  "block.minecraft.banner.half_horizontal.light_blue": "Lyseblå overdel",
  "block.minecraft.banner.half_horizontal.light_gray": "Lysegrå overdel",
  "block.minecraft.banner.half_horizontal.lime": "Limegrønn overdel",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta overdel",
  "block.minecraft.banner.half_horizontal.orange": "Oransje overdel",
  "block.minecraft.banner.half_horizontal.pink": "Rosa overdel",
  "block.minecraft.banner.half_horizontal.purple": "Lilla overdel",
  "block.minecraft.banner.half_horizontal.red": "Rød overdel",
  "block.minecraft.banner.half_horizontal.white": "Hvit overdel",
  "block.minecraft.banner.half_horizontal.yellow": "Gul overdel",
  "block.minecraft.banner.half_horizontal_bottom.black": "Svart underdel",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blå underdel",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brun underdel",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Turkis underdel",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grå underdel",
  "block.minecraft.banner.half_horizontal_bottom.green": "Grønn underdel",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Lyseblå underdel",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Lysegrå underdel",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Limegrønn underdel",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta underdel",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oransje underdel",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Rosa underdel",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Lilla underdel",
  "block.minecraft.banner.half_horizontal_bottom.red": "Rød underdel",
  "block.minecraft.banner.half_horizontal_bottom.white": "Hvit underdel",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Gul underdel",
  "block.minecraft.banner.half_vertical.black": "Svart høyredel",
  "block.minecraft.banner.half_vertical.blue": "Blå høyredel",
  "block.minecraft.banner.half_vertical.brown": "Brun høyredel",
  "block.minecraft.banner.half_vertical.cyan": "Turkis høyredel",
  "block.minecraft.banner.half_vertical.gray": "Grå høyredel",
  "block.minecraft.banner.half_vertical.green": "Grønn høyredel",
  "block.minecraft.banner.half_vertical.light_blue": "Lyseblå høyredel",
  "block.minecraft.banner.half_vertical.light_gray": "Lysegrå høyredel",
  "block.minecraft.banner.half_vertical.lime": "Limegrønn høyredel",
  "block.minecraft.banner.half_vertical.magenta": "Magenta høyredel",
  "block.minecraft.banner.half_vertical.orange": "Oransje høyredel",
  "block.minecraft.banner.half_vertical.pink": "Rosa høyredel",
  "block.minecraft.banner.half_vertical.purple": "Lilla høyredel",
  "block.minecraft.banner.half_vertical.red": "Rød høyredel",
  "block.minecraft.banner.half_vertical.white": "Hvit høyredel",
  "block.minecraft.banner.half_vertical.yellow": "Gul høyredel",
  "block.minecraft.banner.half_vertical_right.black": "Svart venstredel",
  "block.minecraft.banner.half_vertical_right.blue": "Blå venstredel",
  "block.minecraft.banner.half_vertical_right.brown": "Brun venstredel",
  "block.minecraft.banner.half_vertical_right.cyan": "Turkis venstredel",
  "block.minecraft.banner.half_vertical_right.gray": "Grå venstredel",
  "block.minecraft.banner.half_vertical_right.green": "Grønn venstredel",
  "block.minecraft.banner.half_vertical_right.light_blue": "Lyseblå venstredel",
  "block.minecraft.banner.half_vertical_right.light_gray": "Lysegrå venstredel",
  "block.minecraft.banner.half_vertical_right.lime": "Limegrønn venstredel",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta venstredel",
  "block.minecraft.banner.half_vertical_right.orange": "Oransje venstredel",
  "block.minecraft.banner.half_vertical_right.pink": "Rosa venstredel",
  "block.minecraft.banner.half_vertical_right.purple": "Lilla venstredel",
  "block.minecraft.banner.half_vertical_right.red": "Rød venstredel",
  "block.minecraft.banner.half_vertical_right.white": "Hvit venstredel",
  "block.minecraft.banner.half_vertical_right.yellow": "Gul venstredel",
  "block.minecraft.banner.mojang.black": "Svart dings",
  "block.minecraft.banner.mojang.blue": "Blå dings",
  "block.minecraft.banner.mojang.brown": "Brun dings",
  "block.minecraft.banner.mojang.cyan": "Turkis dings",
  "block.minecraft.banner.mojang.gray": "Grå dings",
  "block.minecraft.banner.mojang.green": "Grønn dings",
  "block.minecraft.banner.mojang.light_blue": "Lyseblå dings",
  "block.minecraft.banner.mojang.light_gray": "Lysegrå dings",
  "block.minecraft.banner.mojang.lime": "Limegrønn dings",
  "block.minecraft.banner.mojang.magenta": "Magenta dings",
  "block.minecraft.banner.mojang.orange": "Oransje dings",
  "block.minecraft.banner.mojang.pink": "Rosa dings",
  "block.minecraft.banner.mojang.purple": "Lilla dings",
  "block.minecraft.banner.mojang.red": "Rød dings",
  "block.minecraft.banner.mojang.white": "Hvit dings",
  "block.minecraft.banner.mojang.yellow": "Gul dings",
  "block.minecraft.banner.piglin.black": "Svart snute",
  "block.minecraft.banner.piglin.blue": "Blå snute",
  "block.minecraft.banner.piglin.brown": "Brun snute",
  "block.minecraft.banner.piglin.cyan": "Turkis snute",
  "block.minecraft.banner.piglin.gray": "Grå snute",
  "block.minecraft.banner.piglin.green": "Grønn snute",
  "block.minecraft.banner.piglin.light_blue": "Lyseblå snute",
  "block.minecraft.banner.piglin.light_gray": "Lysegrå snute",
  "block.minecraft.banner.piglin.lime": "Limegrønn snute",
  "block.minecraft.banner.piglin.magenta": "Magenta snute",
  "block.minecraft.banner.piglin.orange": "Oransje snute",
  "block.minecraft.banner.piglin.pink": "Rosa snute",
  "block.minecraft.banner.piglin.purple": "Lilla snute",
  "block.minecraft.banner.piglin.red": "Rød snute",
  "block.minecraft.banner.piglin.white": "Hvit snute",
  "block.minecraft.banner.piglin.yellow": "Gul snute",
  "block.minecraft.banner.rhombus.black": "Svart rute",
  "block.minecraft.banner.rhombus.blue": "Blå rute",
  "block.minecraft.banner.rhombus.brown": "Brun rute",
  "block.minecraft.banner.rhombus.cyan": "Turkis rute",
  "block.minecraft.banner.rhombus.gray": "Grå rute",
  "block.minecraft.banner.rhombus.green": "Grønn rute",
  "block.minecraft.banner.rhombus.light_blue": "Lyseblå rute",
  "block.minecraft.banner.rhombus.light_gray": "Lysegrå rute",
  "block.minecraft.banner.rhombus.lime": "Limegrønn rute",
  "block.minecraft.banner.rhombus.magenta": "Magenta rute",
  "block.minecraft.banner.rhombus.orange": "Oransje rute",
  "block.minecraft.banner.rhombus.pink": "Rosa rute",
  "block.minecraft.banner.rhombus.purple": "Lilla rute",
  "block.minecraft.banner.rhombus.red": "Rød rute",
  "block.minecraft.banner.rhombus.white": "Hvit rute",
  "block.minecraft.banner.rhombus.yellow": "Gul rute",
  "block.minecraft.banner.skull.black": "Svart hodeskalle",
  "block.minecraft.banner.skull.blue": "Blå hodeskalle",
  "block.minecraft.banner.skull.brown": "Brun hodeskalle",
  "block.minecraft.banner.skull.cyan": "Turkis hodeskalle",
  "block.minecraft.banner.skull.gray": "Grå hodeskalle",
  "block.minecraft.banner.skull.green": "Grønn hodeskalle",
  "block.minecraft.banner.skull.light_blue": "Lyseblå hodeskalle",
  "block.minecraft.banner.skull.light_gray": "Lysegrå hodeskalle",
  "block.minecraft.banner.skull.lime": "Limegrønn hodeskalle",
  "block.minecraft.banner.skull.magenta": "Magenta hodeskalle",
  "block.minecraft.banner.skull.orange": "Oransje hodeskalle",
  "block.minecraft.banner.skull.pink": "Rosa hodeskalle",
  "block.minecraft.banner.skull.purple": "Lilla hodeskalle",
  "block.minecraft.banner.skull.red": "Rød hodeskalle",
  "block.minecraft.banner.skull.white": "Hvit hodeskalle",
  "block.minecraft.banner.skull.yellow": "Gul hodeskalle",
  "block.minecraft.banner.small_stripes.black": "Svarte stolper",
  "block.minecraft.banner.small_stripes.blue": "Blå stolper",
  "block.minecraft.banner.small_stripes.brown": "Brune stolper",
  "block.minecraft.banner.small_stripes.cyan": "Turkise stolper",
  "block.minecraft.banner.small_stripes.gray": "Grå stolper",
  "block.minecraft.banner.small_stripes.green": "Grønne stolper",
  "block.minecraft.banner.small_stripes.light_blue": "Lyseblå stolper",
  "block.minecraft.banner.small_stripes.light_gray": "Lysegrå stolper",
  "block.minecraft.banner.small_stripes.lime": "Limegrønne stolper",
  "block.minecraft.banner.small_stripes.magenta": "Magenta stolper",
  "block.minecraft.banner.small_stripes.orange": "Oransje stolper",
  "block.minecraft.banner.small_stripes.pink": "Rosa stolper",
  "block.minecraft.banner.small_stripes.purple": "Lilla stolper",
  "block.minecraft.banner.small_stripes.red": "Røde stolper",
  "block.minecraft.banner.small_stripes.white": "Hvite stolper",
  "block.minecraft.banner.small_stripes.yellow": "Gule stolper",
  "block.minecraft.banner.square_bottom_left.black": "Svart høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.blue": "Blå høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.brown": "Brun høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.cyan": "Turkis høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.gray": "Grå høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.green": "Grønn høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.light_blue": "Lyseblå høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.light_gray": "Lysegrå høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.lime": "Limegrønn høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.orange": "Oransje høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.pink": "Rosa høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.purple": "Lilla høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.red": "Rød høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.white": "Hvit høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_left.yellow": "Gul høyrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.black": "Svart venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.blue": "Blå venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.brown": "Brun venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.cyan": "Turkis venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.gray": "Grå venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.green": "Grønn venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.light_blue": "Lyseblå venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.light_gray": "Lysegrå venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.lime": "Limegrønn venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.orange": "Oransje venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.pink": "Rosa venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.purple": "Lilla venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.red": "Rød venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.white": "Hvit venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_bottom_right.yellow": "Gul venstrekanton i skjoldfoten",
  "block.minecraft.banner.square_top_left.black": "Svart høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.blue": "Blå høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.brown": "Brun høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.cyan": "Turkis høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.gray": "Grå høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.green": "Grønn høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.light_blue": "Lyseblå høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.light_gray": "Lysegrå høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.lime": "Limegrønn høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.magenta": "Magenta høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.orange": "Oransje høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.pink": "Rosa høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.purple": "Lilla høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.red": "Rød høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.white": "Hvit høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_left.yellow": "Gul høyrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.black": "Svart venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.blue": "Blå venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.brown": "Brun venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.cyan": "Turkis venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.gray": "Grå venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.green": "Grønn venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.light_blue": "Lyseblå venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.light_gray": "Lysegrå venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.lime": "Limegrønn venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.magenta": "Magenta venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.orange": "Oransje venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.pink": "Rosa venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.purple": "Lilla venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.red": "Rød venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.white": "Hvit venstrekanton i skjoldhodet",
  "block.minecraft.banner.square_top_right.yellow": "Gul venstrekanton i skjoldhodet",
  "block.minecraft.banner.straight_cross.black": "Svart kors",
  "block.minecraft.banner.straight_cross.blue": "Blått kors",
  "block.minecraft.banner.straight_cross.brown": "Brunt kors",
  "block.minecraft.banner.straight_cross.cyan": "Turkist kors",
  "block.minecraft.banner.straight_cross.gray": "Grått kors",
  "block.minecraft.banner.straight_cross.green": "Grønt kors",
  "block.minecraft.banner.straight_cross.light_blue": "Lyseblått kors",
  "block.minecraft.banner.straight_cross.light_gray": "Lysegrått kors",
  "block.minecraft.banner.straight_cross.lime": "Limegrønt kors",
  "block.minecraft.banner.straight_cross.magenta": "Magenta kors",
  "block.minecraft.banner.straight_cross.orange": "Oransje kors",
  "block.minecraft.banner.straight_cross.pink": "Rosa kors",
  "block.minecraft.banner.straight_cross.purple": "Lilla kors",
  "block.minecraft.banner.straight_cross.red": "Rødt kors",
  "block.minecraft.banner.straight_cross.white": "Hvitt kors",
  "block.minecraft.banner.straight_cross.yellow": "Gult kors",
  "block.minecraft.banner.stripe_bottom.black": "Svart skjoldfot",
  "block.minecraft.banner.stripe_bottom.blue": "Blå skjoldfot",
  "block.minecraft.banner.stripe_bottom.brown": "Brun skjoldfot",
  "block.minecraft.banner.stripe_bottom.cyan": "Turkis skjoldfot",
  "block.minecraft.banner.stripe_bottom.gray": "Grå skjoldfot",
  "block.minecraft.banner.stripe_bottom.green": "Grønn skjoldfot",
  "block.minecraft.banner.stripe_bottom.light_blue": "Lyseblå skjoldfot",
  "block.minecraft.banner.stripe_bottom.light_gray": "Lysegrå skjoldfot",
  "block.minecraft.banner.stripe_bottom.lime": "Limegrønn skjoldfot",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta skjoldfot",
  "block.minecraft.banner.stripe_bottom.orange": "Oransje skjoldfot",
  "block.minecraft.banner.stripe_bottom.pink": "Rosa skjoldfot",
  "block.minecraft.banner.stripe_bottom.purple": "Lilla skjoldfot",
  "block.minecraft.banner.stripe_bottom.red": "Rød skjoldfot",
  "block.minecraft.banner.stripe_bottom.white": "Hvit skjoldfot",
  "block.minecraft.banner.stripe_bottom.yellow": "Gul skjoldfot",
  "block.minecraft.banner.stripe_center.black": "Svart stolpe",
  "block.minecraft.banner.stripe_center.blue": "Blå stolpe",
  "block.minecraft.banner.stripe_center.brown": "Brun stolpe",
  "block.minecraft.banner.stripe_center.cyan": "Turkis stolpe",
  "block.minecraft.banner.stripe_center.gray": "Grå stolpe",
  "block.minecraft.banner.stripe_center.green": "Grønn stolpe",
  "block.minecraft.banner.stripe_center.light_blue": "Lyseblå stolpe",
  "block.minecraft.banner.stripe_center.light_gray": "Lysegrå stolpe",
  "block.minecraft.banner.stripe_center.lime": "Limegrønn stolpe",
  "block.minecraft.banner.stripe_center.magenta": "Magenta stolpe",
  "block.minecraft.banner.stripe_center.orange": "Oransje stolpe",
  "block.minecraft.banner.stripe_center.pink": "Rosa stolpe",
  "block.minecraft.banner.stripe_center.purple": "Lilla stolpe",
  "block.minecraft.banner.stripe_center.red": "Rød stolpe",
  "block.minecraft.banner.stripe_center.white": "Hvit stolpe",
  "block.minecraft.banner.stripe_center.yellow": "Gul stolpe",
  "block.minecraft.banner.stripe_downleft.black": "Svart venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.blue": "Blå venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.brown": "Brun venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.cyan": "Turkis venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.gray": "Grå venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.green": "Grønn venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.light_blue": "Lyseblå venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.light_gray": "Lysegrå venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.lime": "Limegrønn venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.orange": "Oransje venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.pink": "Rosa venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.purple": "Lilla venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.red": "Rød venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.white": "Hvit venstreskråbjelke",
  "block.minecraft.banner.stripe_downleft.yellow": "Gul venstreskråbjelke",
  "block.minecraft.banner.stripe_downright.black": "Svart skråbjelke",
  "block.minecraft.banner.stripe_downright.blue": "Blå skråbjelke",
  "block.minecraft.banner.stripe_downright.brown": "Brun skråbjelke",
  "block.minecraft.banner.stripe_downright.cyan": "Turkis skråbjelke",
  "block.minecraft.banner.stripe_downright.gray": "Grå skråbjelke",
  "block.minecraft.banner.stripe_downright.green": "Grønn skråbjelke",
  "block.minecraft.banner.stripe_downright.light_blue": "Lyseblå skråbjelke",
  "block.minecraft.banner.stripe_downright.light_gray": "Lysegrå skråbjelke",
  "block.minecraft.banner.stripe_downright.lime": "Limegrønn skråbjelke",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta skråbjelke",
  "block.minecraft.banner.stripe_downright.orange": "Oransje skråbjelke",
  "block.minecraft.banner.stripe_downright.pink": "Rosa skråbjelke",
  "block.minecraft.banner.stripe_downright.purple": "Lilla skråbjelke",
  "block.minecraft.banner.stripe_downright.red": "Rød skråbjelke",
  "block.minecraft.banner.stripe_downright.white": "Hvit skråbjelke",
  "block.minecraft.banner.stripe_downright.yellow": "Gul skråbjelke",
  "block.minecraft.banner.stripe_left.black": "Svart høyrestolpe",
  "block.minecraft.banner.stripe_left.blue": "Blå høyrestolpe",
  "block.minecraft.banner.stripe_left.brown": "Brun høyrestolpe",
  "block.minecraft.banner.stripe_left.cyan": "Turkis høyrestolpe",
  "block.minecraft.banner.stripe_left.gray": "Grå høyrestolpe",
  "block.minecraft.banner.stripe_left.green": "Grønn høyrestolpe",
  "block.minecraft.banner.stripe_left.light_blue": "Lyseblå høyrestolpe",
  "block.minecraft.banner.stripe_left.light_gray": "Lysegrå høyrestolpe",
  "block.minecraft.banner.stripe_left.lime": "Limegrønn høyrestolpe",
  "block.minecraft.banner.stripe_left.magenta": "Magenta høyrestolpe",
  "block.minecraft.banner.stripe_left.orange": "Oransje høyrestolpe",
  "block.minecraft.banner.stripe_left.pink": "Rosa høyrestolpe",
  "block.minecraft.banner.stripe_left.purple": "Lilla høyrestolpe",
  "block.minecraft.banner.stripe_left.red": "Rød høyrestolpe",
  "block.minecraft.banner.stripe_left.white": "Hvit høyrestolpe",
  "block.minecraft.banner.stripe_left.yellow": "Gul høyrestolpe",
  "block.minecraft.banner.stripe_middle.black": "Svart bjelke",
  "block.minecraft.banner.stripe_middle.blue": "Blå bjelke",
  "block.minecraft.banner.stripe_middle.brown": "Brun bjelke",
  "block.minecraft.banner.stripe_middle.cyan": "Turkis bjelke",
  "block.minecraft.banner.stripe_middle.gray": "Grå bjelke",
  "block.minecraft.banner.stripe_middle.green": "Grønn bjelke",
  "block.minecraft.banner.stripe_middle.light_blue": "Lyseblå bjelke",
  "block.minecraft.banner.stripe_middle.light_gray": "Lysegrå bjelke",
  "block.minecraft.banner.stripe_middle.lime": "Limegrønn bjelke",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta bjelke",
  "block.minecraft.banner.stripe_middle.orange": "Oransje bjelke",
  "block.minecraft.banner.stripe_middle.pink": "Rosa bjelke",
  "block.minecraft.banner.stripe_middle.purple": "Lilla bjelke",
  "block.minecraft.banner.stripe_middle.red": "Rød bjelke",
  "block.minecraft.banner.stripe_middle.white": "Hvit bjelke",
  "block.minecraft.banner.stripe_middle.yellow": "Gul bjelke",
  "block.minecraft.banner.stripe_right.black": "Svart venstrestolpe",
  "block.minecraft.banner.stripe_right.blue": "Blå venstrestolpe",
  "block.minecraft.banner.stripe_right.brown": "Brun venstrestolpe",
  "block.minecraft.banner.stripe_right.cyan": "Turkis venstrestolpe",
  "block.minecraft.banner.stripe_right.gray": "Grå venstrestolpe",
  "block.minecraft.banner.stripe_right.green": "Grønn venstrestolpe",
  "block.minecraft.banner.stripe_right.light_blue": "Lyseblå venstrestolpe",
  "block.minecraft.banner.stripe_right.light_gray": "Lysegrå venstrestolpe",
  "block.minecraft.banner.stripe_right.lime": "Limegrønn venstrestolpe",
  "block.minecraft.banner.stripe_right.magenta": "Magenta venstrestolpe",
  "block.minecraft.banner.stripe_right.orange": "Oransje venstrestolpe",
  "block.minecraft.banner.stripe_right.pink": "Rosa venstrestolpe",
  "block.minecraft.banner.stripe_right.purple": "Lilla venstrestolpe",
  "block.minecraft.banner.stripe_right.red": "Rød venstrestolpe",
  "block.minecraft.banner.stripe_right.white": "Hvit venstrestolpe",
  "block.minecraft.banner.stripe_right.yellow": "Gul venstrestolpe",
  "block.minecraft.banner.stripe_top.black": "Svart skjoldhode",
  "block.minecraft.banner.stripe_top.blue": "Blått skjoldhode",
  "block.minecraft.banner.stripe_top.brown": "Brunt skjoldhode",
  "block.minecraft.banner.stripe_top.cyan": "Turkist skjoldhode",
  "block.minecraft.banner.stripe_top.gray": "Grått skjoldhode",
  "block.minecraft.banner.stripe_top.green": "Grønt skjoldhode",
  "block.minecraft.banner.stripe_top.light_blue": "Lyseblått skjoldhode",
  "block.minecraft.banner.stripe_top.light_gray": "Lysegrått skjoldhode",
  "block.minecraft.banner.stripe_top.lime": "Limegrønt skjoldhode",
  "block.minecraft.banner.stripe_top.magenta": "Magenta skjoldhode",
  "block.minecraft.banner.stripe_top.orange": "Oransje skjoldhode",
  "block.minecraft.banner.stripe_top.pink": "Rosa skjoldhode",
  "block.minecraft.banner.stripe_top.purple": "Lilla skjoldhode",
  "block.minecraft.banner.stripe_top.red": "Rødt skjoldhode",
  "block.minecraft.banner.stripe_top.white": "Hvitt skjoldhode",
  "block.minecraft.banner.stripe_top.yellow": "Gult skjoldhode",
  "block.minecraft.banner.triangle_bottom.black": "Svart sparre",
  "block.minecraft.banner.triangle_bottom.blue": "Blå sparre",
  "block.minecraft.banner.triangle_bottom.brown": "Brun sparre",
  "block.minecraft.banner.triangle_bottom.cyan": "Turkis sparre",
  "block.minecraft.banner.triangle_bottom.gray": "Grå sparre",
  "block.minecraft.banner.triangle_bottom.green": "Grønn sparre",
  "block.minecraft.banner.triangle_bottom.light_blue": "Lyseblå sparre",
  "block.minecraft.banner.triangle_bottom.light_gray": "Lysegrå sparre",
  "block.minecraft.banner.triangle_bottom.lime": "Limegrønn sparre",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta sparre",
  "block.minecraft.banner.triangle_bottom.orange": "Oransje sparre",
  "block.minecraft.banner.triangle_bottom.pink": "Rosa sparre",
  "block.minecraft.banner.triangle_bottom.purple": "Lilla sparre",
  "block.minecraft.banner.triangle_bottom.red": "Rød sparre",
  "block.minecraft.banner.triangle_bottom.white": "Hvit sparre",
  "block.minecraft.banner.triangle_bottom.yellow": "Gul sparre",
  "block.minecraft.banner.triangle_top.black": "Svart sparre (omvendt)",
  "block.minecraft.banner.triangle_top.blue": "Blå sparre (omvendt)",
  "block.minecraft.banner.triangle_top.brown": "Brun sparre (omvendt)",
  "block.minecraft.banner.triangle_top.cyan": "Turkis sparre (omvendt)",
  "block.minecraft.banner.triangle_top.gray": "Grå sparre (omvendt)",
  "block.minecraft.banner.triangle_top.green": "Grønn sparre (omvendt)",
  "block.minecraft.banner.triangle_top.light_blue": "Lyseblå sparre (omvendt)",
  "block.minecraft.banner.triangle_top.light_gray": "Lysegrå sparre (omvendt)",
  "block.minecraft.banner.triangle_top.lime": "Limegrønn sparre (omvendt)",
  "block.minecraft.banner.triangle_top.magenta": "Magenta sparre (omvendt)",
  "block.minecraft.banner.triangle_top.orange": "Oransje sparre (omvendt)",
  "block.minecraft.banner.triangle_top.pink": "Rosa sparre (omvendt)",
  "block.minecraft.banner.triangle_top.purple": "Lilla sparre (omvendt)",
  "block.minecraft.banner.triangle_top.red": "Rød sparre (omvendt)",
  "block.minecraft.banner.triangle_top.white": "Hvit sparre (omvendt)",
  "block.minecraft.banner.triangle_top.yellow": "Gul sparre (omvendt)",
  "block.minecraft.banner.triangles_bottom.black": "Svart tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.blue": "Blått tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.brown": "Brunt tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.cyan": "Turkist tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.gray": "Grått tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.green": "Grønt tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.light_blue": "Lyseblått tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.light_gray": "Lysegrått tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.lime": "Limegrønt tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.orange": "Oransje tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.pink": "Rosa tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.purple": "Lilla tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.red": "Rødt tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.white": "Hvitt tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_bottom.yellow": "Gult tannsnitt i skjoldfot",
  "block.minecraft.banner.triangles_top.black": "Svart tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.blue": "Blått tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.brown": "Brunt tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.cyan": "Turkist tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.gray": "Grått tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.green": "Grønt tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.light_blue": "Lyseblått tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.light_gray": "Lysegrått tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.lime": "Limegrønt tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.magenta": "Magenta tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.orange": "Oransje tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.pink": "Rosa tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.purple": "Lilla tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.red": "Rødt tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.white": "Hvitt tannsnitt i skjoldhodet",
  "block.minecraft.banner.triangles_top.yellow": "Gult tannsnitt i skjoldhodet",
  "block.minecraft.barrel": "Tønne",
  "block.minecraft.barrier": "Barriere",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Varde",
  "block.minecraft.beacon.primary": "Primærkraft",
  "block.minecraft.beacon.secondary": "Sekundærkraft",
  "block.minecraft.bed.no_sleep": "Du kan kun sove om natten eller i løpet av tordenvær",
  "block.minecraft.bed.not_safe": "Du kan ikke sove nå; det er monstre i nærheten",
  "block.minecraft.bed.obstructed": "Denne sengen er blokkert",
  "block.minecraft.bed.occupied": "Denne sengen er opptatt",
  "block.minecraft.bed.too_far_away": "Du kan ikke sove nå; sengen er for langt unna",
  "block.minecraft.bedrock": "Grunnfjell",
  "block.minecraft.bee_nest": "Biebol",
  "block.minecraft.beehive": "Bikube",
  "block.minecraft.beetroots": "Rødbeter",
  "block.minecraft.bell": "Bjelle",
  "block.minecraft.big_dripleaf": "Stort dråpeblad",
  "block.minecraft.big_dripleaf_stem": "Stor dråpebladsstilk",
  "block.minecraft.birch_button": "Bjørkeknapp",
  "block.minecraft.birch_door": "Bjørkedør",
  "block.minecraft.birch_fence": "Bjørkegjerde",
  "block.minecraft.birch_fence_gate": "Bjørkegrind",
  "block.minecraft.birch_hanging_sign": "Hengende bjørkeskilt",
  "block.minecraft.birch_leaves": "Bjørkeløv",
  "block.minecraft.birch_log": "Bjørketømmer",
  "block.minecraft.birch_planks": "Bjørkeplanker",
  "block.minecraft.birch_pressure_plate": "Bjørketrykkplate",
  "block.minecraft.birch_sapling": "Bjørkespire",
  "block.minecraft.birch_shelf": "Bjørkehylle",
  "block.minecraft.birch_sign": "Bjørkeskilt",
  "block.minecraft.birch_slab": "Bjørkehelle",
  "block.minecraft.birch_stairs": "Bjørketrapp",
  "block.minecraft.birch_trapdoor": "Bjørkefallem",
  "block.minecraft.birch_wall_hanging_sign": "Vegghengende bjørkeskilt",
  "block.minecraft.birch_wall_sign": "Bjørkeveggskilt",
  "block.minecraft.birch_wood": "Bjørketre",
  "block.minecraft.black_banner": "Svart banner",
  "block.minecraft.black_bed": "Svart seng",
  "block.minecraft.black_candle": "Svart vokslys",
  "block.minecraft.black_candle_cake": "Kake med svart lys",
  "block.minecraft.black_carpet": "Svart teppe",
  "block.minecraft.black_concrete": "Svart betong",
  "block.minecraft.black_concrete_powder": "Svart sement",
  "block.minecraft.black_glazed_terracotta": "Svart glasert terrakotta",
  "block.minecraft.black_shulker_box": "Svart shulkerboks",
  "block.minecraft.black_stained_glass": "Svart farget glass",
  "block.minecraft.black_stained_glass_pane": "Svart farget glassrute",
  "block.minecraft.black_terracotta": "Svart terrakotta",
  "block.minecraft.black_wool": "Svart ull",
  "block.minecraft.blackstone": "Svartstein",
  "block.minecraft.blackstone_slab": "Helle av svartstein",
  "block.minecraft.blackstone_stairs": "Trapp av svartstein",
  "block.minecraft.blackstone_wall": "Mur av svartstein",
  "block.minecraft.blast_furnace": "Masovn",
  "block.minecraft.blue_banner": "Blått banner",
  "block.minecraft.blue_bed": "Blå seng",
  "block.minecraft.blue_candle": "Blått vokslys",
  "block.minecraft.blue_candle_cake": "Kake med blått lys",
  "block.minecraft.blue_carpet": "Blått teppe",
  "block.minecraft.blue_concrete": "Blå betong",
  "block.minecraft.blue_concrete_powder": "Blå sement",
  "block.minecraft.blue_glazed_terracotta": "Blå glasert terrakotta",
  "block.minecraft.blue_ice": "Blåis",
  "block.minecraft.blue_orchid": "Blå orkidé",
  "block.minecraft.blue_shulker_box": "Blå shulkerboks",
  "block.minecraft.blue_stained_glass": "Blått farget glass",
  "block.minecraft.blue_stained_glass_pane": "Blå farget glassrute",
  "block.minecraft.blue_terracotta": "Blå terrakotta",
  "block.minecraft.blue_wool": "Blå ull",
  "block.minecraft.bone_block": "Beinblokk",
  "block.minecraft.bookshelf": "Bokhylle",
  "block.minecraft.brain_coral": "Hjernekorall",
  "block.minecraft.brain_coral_block": "Hjernekorallblokk",
  "block.minecraft.brain_coral_fan": "Hjernekorallvifte",
  "block.minecraft.brain_coral_wall_fan": "Hjernekorallveggvifte",
  "block.minecraft.brewing_stand": "Bryggestativ",
  "block.minecraft.brick_slab": "Helle av tegl",
  "block.minecraft.brick_stairs": "Trapp av tegl",
  "block.minecraft.brick_wall": "Mur av tegl",
  "block.minecraft.bricks": "Tegl",
  "block.minecraft.brown_banner": "Brunt banner",
  "block.minecraft.brown_bed": "Brun seng",
  "block.minecraft.brown_candle": "Brunt vokslys",
  "block.minecraft.brown_candle_cake": "Kake med brunt lys",
  "block.minecraft.brown_carpet": "Brunt teppe",
  "block.minecraft.brown_concrete": "Brun betong",
  "block.minecraft.brown_concrete_powder": "Brun sement",
  "block.minecraft.brown_glazed_terracotta": "Brun glasert terrakotta",
  "block.minecraft.brown_mushroom": "Brun sopp",
  "block.minecraft.brown_mushroom_block": "Brun soppblokk",
  "block.minecraft.brown_shulker_box": "Brun shulkerboks",
  "block.minecraft.brown_stained_glass": "Brunt farget glass",
  "block.minecraft.brown_stained_glass_pane": "Brun farget glassrute",
  "block.minecraft.brown_terracotta": "Brun terrakotta",
  "block.minecraft.brown_wool": "Brun ull",
  "block.minecraft.bubble_column": "Boblekolonne",
  "block.minecraft.bubble_coral": "Boblekorall",
  "block.minecraft.bubble_coral_block": "Boblekorallblokk",
  "block.minecraft.bubble_coral_fan": "Boblekorallvifte",
  "block.minecraft.bubble_coral_wall_fan": "Boblekorallveggvifte",
  "block.minecraft.budding_amethyst": "Spirende ametyst",
  "block.minecraft.bush": "Busk",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblomst",
  "block.minecraft.cake": "Kake",
  "block.minecraft.calcite": "Kalsitt",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrert sculksensor",
  "block.minecraft.campfire": "Bål",
  "block.minecraft.candle": "Vokslys",
  "block.minecraft.candle_cake": "Kake med lys",
  "block.minecraft.carrots": "Gulrøtter",
  "block.minecraft.cartography_table": "Karttegningsbenk",
  "block.minecraft.carved_pumpkin": "Utskåret gresskar",
  "block.minecraft.cauldron": "Gryte",
  "block.minecraft.cave_air": "Huleluft",
  "block.minecraft.cave_vines": "Grotteranke",
  "block.minecraft.cave_vines_plant": "Grotteranke",
  "block.minecraft.chain": "Kjetting",
  "block.minecraft.chain_command_block": "Kjede-kommandoblokk",
  "block.minecraft.cherry_button": "Kirsebærtreknapp",
  "block.minecraft.cherry_door": "Kirsebærtredør",
  "block.minecraft.cherry_fence": "Kirsebærtregjerde",
  "block.minecraft.cherry_fence_gate": "Kirsebærtregrind",
  "block.minecraft.cherry_hanging_sign": "Hengende kirsebærtreskilt",
  "block.minecraft.cherry_leaves": "Kirsebærløv",
  "block.minecraft.cherry_log": "Kirsebærtømmer",
  "block.minecraft.cherry_planks": "Kirsebærtreplanker",
  "block.minecraft.cherry_pressure_plate": "Kirsebærtretrykkplate",
  "block.minecraft.cherry_sapling": "Kirsebærtrespire",
  "block.minecraft.cherry_shelf": "Kirsebærtrehylle",
  "block.minecraft.cherry_sign": "Kirsebærtreskilt",
  "block.minecraft.cherry_slab": "Kirsebærtrehelle",
  "block.minecraft.cherry_stairs": "Kirsebærtretrapp",
  "block.minecraft.cherry_trapdoor": "Kirsebærtrefallem",
  "block.minecraft.cherry_wall_hanging_sign": "Vegghengende kirsebærtreskilt",
  "block.minecraft.cherry_wall_sign": "Kirsebærtreveggskilt",
  "block.minecraft.cherry_wood": "Kirsebærtre",
  "block.minecraft.chest": "Kiste",
  "block.minecraft.chipped_anvil": "Sprukket ambolt",
  "block.minecraft.chiseled_bookshelf": "Utskåret bokhylle",
  "block.minecraft.chiseled_copper": "Uthugget kobber",
  "block.minecraft.chiseled_deepslate": "Uthugget dypskifer",
  "block.minecraft.chiseled_nether_bricks": "Uthugget nethertegl",
  "block.minecraft.chiseled_polished_blackstone": "Uthugget finslipt svartstein",
  "block.minecraft.chiseled_quartz_block": "Uthugget kvartsblokk",
  "block.minecraft.chiseled_red_sandstone": "Uthugget rød sandstein",
  "block.minecraft.chiseled_resin_bricks": "Uthugget kvaetegl",
  "block.minecraft.chiseled_sandstone": "Uthugget sandstein",
  "block.minecraft.chiseled_stone_bricks": "Uthugget steinmur",
  "block.minecraft.chiseled_tuff": "Uthugget tuffstein",
  "block.minecraft.chiseled_tuff_bricks": "Uthugget tuffsteintegl",
  "block.minecraft.chorus_flower": "Refrengblomst",
  "block.minecraft.chorus_plant": "Refrengplante",
  "block.minecraft.clay": "Leire",
  "block.minecraft.closed_eyeblossom": "Lukket øyeblom",
  "block.minecraft.coal_block": "Kullblokk",
  "block.minecraft.coal_ore": "Kullåre",
  "block.minecraft.coarse_dirt": "Grov jord",
  "block.minecraft.cobbled_deepslate": "Brolagt dypskifer",
  "block.minecraft.cobbled_deepslate_slab": "Helle av brolagt dypskifer",
  "block.minecraft.cobbled_deepslate_stairs": "Trapp av brolagt dypskifer",
  "block.minecraft.cobbled_deepslate_wall": "Mur av brolagt dypskifer",
  "block.minecraft.cobblestone": "Brostein",
  "block.minecraft.cobblestone_slab": "Helle av brostein",
  "block.minecraft.cobblestone_stairs": "Trapp av brostein",
  "block.minecraft.cobblestone_wall": "Mur av brostein",
  "block.minecraft.cobweb": "Spindelvev",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Kommandoblokk",
  "block.minecraft.comparator": "Redstonesammenligner",
  "block.minecraft.composter": "Kompostbinge",
  "block.minecraft.conduit": "Fløder",
  "block.minecraft.copper_bars": "Kobbergitter",
  "block.minecraft.copper_block": "Kobberblokk",
  "block.minecraft.copper_bulb": "Kobberpære",
  "block.minecraft.copper_chain": "Kobberkjetting",
  "block.minecraft.copper_chest": "Kobberkiste",
  "block.minecraft.copper_door": "Kobberdør",
  "block.minecraft.copper_golem_statue": "Kobbergubbestatue",
  "block.minecraft.copper_grate": "Kobberrist",
  "block.minecraft.copper_lantern": "Kobberlykt",
  "block.minecraft.copper_ore": "Kobberåre",
  "block.minecraft.copper_torch": "Kobberfakkel",
  "block.minecraft.copper_trapdoor": "Kobberfallem",
  "block.minecraft.copper_wall_torch": "Kobberveggfakkel",
  "block.minecraft.cornflower": "Kornblomst",
  "block.minecraft.cracked_deepslate_bricks": "Sprukken dypskifermur",
  "block.minecraft.cracked_deepslate_tiles": "Sprukne dypskiferfliser",
  "block.minecraft.cracked_nether_bricks": "Sprukket nethertegl",
  "block.minecraft.cracked_polished_blackstone_bricks": "Sprukket finslipt svartsteinsmur",
  "block.minecraft.cracked_stone_bricks": "Sprukket steinmur",
  "block.minecraft.crafter": "Tilvirker",
  "block.minecraft.crafting_table": "Arbeidsbenk",
  "block.minecraft.creaking_heart": "Knirkningshjerte",
  "block.minecraft.creeper_head": "Creeperhode",
  "block.minecraft.creeper_wall_head": "Creepervegghode",
  "block.minecraft.crimson_button": "Karmosinknapp",
  "block.minecraft.crimson_door": "Karmosindør",
  "block.minecraft.crimson_fence": "Karmosingjerde",
  "block.minecraft.crimson_fence_gate": "Karmosingrind",
  "block.minecraft.crimson_fungus": "Karmosinsopp",
  "block.minecraft.crimson_hanging_sign": "Hengende karmosinskilt",
  "block.minecraft.crimson_hyphae": "Karmosinhyfe",
  "block.minecraft.crimson_nylium": "Karmosinnycel",
  "block.minecraft.crimson_planks": "Karmosinplanker",
  "block.minecraft.crimson_pressure_plate": "Karmosintrykkplate",
  "block.minecraft.crimson_roots": "Karmosinrøtter",
  "block.minecraft.crimson_shelf": "Karmosinhylle",
  "block.minecraft.crimson_sign": "Karmosinskilt",
  "block.minecraft.crimson_slab": "Karmonsinhelle",
  "block.minecraft.crimson_stairs": "Karmosintrapp",
  "block.minecraft.crimson_stem": "Karmosinstilk",
  "block.minecraft.crimson_trapdoor": "Karmosinfallem",
  "block.minecraft.crimson_wall_hanging_sign": "Vegghengende karmosinskilt",
  "block.minecraft.crimson_wall_sign": "Karmosinveggskilt",
  "block.minecraft.crying_obsidian": "Gråtende obsidian",
  "block.minecraft.cut_copper": "Skåret kobber",
  "block.minecraft.cut_copper_slab": "Helle av skåret kobber",
  "block.minecraft.cut_copper_stairs": "Trapp av skåret kobber",
  "block.minecraft.cut_red_sandstone": "Skåret rød sandstein",
  "block.minecraft.cut_red_sandstone_slab": "Helle av skåret rød sandstein",
  "block.minecraft.cut_sandstone": "Skåret sandstein",
  "block.minecraft.cut_sandstone_slab": "Helle av skåret sandstein",
  "block.minecraft.cyan_banner": "Turkist banner",
  "block.minecraft.cyan_bed": "Turkis seng",
  "block.minecraft.cyan_candle": "Turkis vokslys",
  "block.minecraft.cyan_candle_cake": "Kake med blågrønt lys",
  "block.minecraft.cyan_carpet": "Turkist teppe",
  "block.minecraft.cyan_concrete": "Turkis betong",
  "block.minecraft.cyan_concrete_powder": "Blågrønn sement",
  "block.minecraft.cyan_glazed_terracotta": "Turkis glasert terrakotta",
  "block.minecraft.cyan_shulker_box": "Turkis shulkerboks",
  "block.minecraft.cyan_stained_glass": "Cyan farget glass",
  "block.minecraft.cyan_stained_glass_pane": "Cyan farget glassrute",
  "block.minecraft.cyan_terracotta": "Turkis terrakotta",
  "block.minecraft.cyan_wool": "Turkis ull",
  "block.minecraft.damaged_anvil": "Skadet ambolt",
  "block.minecraft.dandelion": "Løvetann",
  "block.minecraft.dark_oak_button": "Mørkeikeknapp",
  "block.minecraft.dark_oak_door": "Mørkeikedør",
  "block.minecraft.dark_oak_fence": "Mørkeikegjerde",
  "block.minecraft.dark_oak_fence_gate": "Mørkeikegrind",
  "block.minecraft.dark_oak_hanging_sign": "Hengende mørkeikeskilt",
  "block.minecraft.dark_oak_leaves": "Mørkeikeløv",
  "block.minecraft.dark_oak_log": "Mørkeiketømmer",
  "block.minecraft.dark_oak_planks": "Mørkeikeplanker",
  "block.minecraft.dark_oak_pressure_plate": "Mørkeiketrykkplate",
  "block.minecraft.dark_oak_sapling": "Mørkeikespire",
  "block.minecraft.dark_oak_shelf": "Mørkeikehylle",
  "block.minecraft.dark_oak_sign": "Mørkeikeskilt",
  "block.minecraft.dark_oak_slab": "Mørkeikehelle",
  "block.minecraft.dark_oak_stairs": "Mørkeiketrapp",
  "block.minecraft.dark_oak_trapdoor": "Mørkeikefallem",
  "block.minecraft.dark_oak_wall_hanging_sign": "Vegghengende mørkeikeskilt",
  "block.minecraft.dark_oak_wall_sign": "Mørkeikeveggskilt",
  "block.minecraft.dark_oak_wood": "Mørkeiketre",
  "block.minecraft.dark_prismarine": "Mørk prismarin",
  "block.minecraft.dark_prismarine_slab": "Helle av mørk prismarin",
  "block.minecraft.dark_prismarine_stairs": "Trapp av mørk prismarin",
  "block.minecraft.daylight_detector": "Dagslyssensor",
  "block.minecraft.dead_brain_coral": "Død hjernekorall",
  "block.minecraft.dead_brain_coral_block": "Død hjernekorallblokk",
  "block.minecraft.dead_brain_coral_fan": "Død hjernekorallvifte",
  "block.minecraft.dead_brain_coral_wall_fan": "Død hjernekorallveggvifte",
  "block.minecraft.dead_bubble_coral": "Død boblekorall",
  "block.minecraft.dead_bubble_coral_block": "Død boblekorallblokk",
  "block.minecraft.dead_bubble_coral_fan": "Død boblekorallvifte",
  "block.minecraft.dead_bubble_coral_wall_fan": "Død boblekorallveggvifte",
  "block.minecraft.dead_bush": "Vissen busk",
  "block.minecraft.dead_fire_coral": "Død ildkorall",
  "block.minecraft.dead_fire_coral_block": "Død ildkorallblokk",
  "block.minecraft.dead_fire_coral_fan": "Død ildkorallvifte",
  "block.minecraft.dead_fire_coral_wall_fan": "Død ildkorallveggvifte",
  "block.minecraft.dead_horn_coral": "Død hornkorall",
  "block.minecraft.dead_horn_coral_block": "Død hornkorallblokk",
  "block.minecraft.dead_horn_coral_fan": "Død hornkorallvifte",
  "block.minecraft.dead_horn_coral_wall_fan": "Død hornkorallveggvifte",
  "block.minecraft.dead_tube_coral": "Død orgelkorall",
  "block.minecraft.dead_tube_coral_block": "Død orgelkorallblokk",
  "block.minecraft.dead_tube_coral_fan": "Død orgelkorallvifte",
  "block.minecraft.dead_tube_coral_wall_fan": "Død orgelkorallveggvifte",
  "block.minecraft.decorated_pot": "Dekorert potte",
  "block.minecraft.deepslate": "Dypskifer",
  "block.minecraft.deepslate_brick_slab": "Helle av dypskifermur",
  "block.minecraft.deepslate_brick_stairs": "Trapp av dypskifermur",
  "block.minecraft.deepslate_brick_wall": "Mur av dypskifermur",
  "block.minecraft.deepslate_bricks": "Dypskifermur",
  "block.minecraft.deepslate_coal_ore": "Kullåre i dypskifer",
  "block.minecraft.deepslate_copper_ore": "Kobberåre i dypskifer",
  "block.minecraft.deepslate_diamond_ore": "Diamantåre i dypskifer",
  "block.minecraft.deepslate_emerald_ore": "Smaragdåre i dypskifer",
  "block.minecraft.deepslate_gold_ore": "Gullåre i dypskifer",
  "block.minecraft.deepslate_iron_ore": "Jernåre i dypskifer",
  "block.minecraft.deepslate_lapis_ore": "Lasursteinåre i dypskifer",
  "block.minecraft.deepslate_redstone_ore": "Redstoneåre i dypskifer",
  "block.minecraft.deepslate_tile_slab": "Helle av dypskiferfliser",
  "block.minecraft.deepslate_tile_stairs": "Trapp av dypskiferfliser",
  "block.minecraft.deepslate_tile_wall": "Mur av dypskiferfliser",
  "block.minecraft.deepslate_tiles": "Dypskiferfliser",
  "block.minecraft.detector_rail": "Detektorskinne",
  "block.minecraft.diamond_block": "Diamantblokk",
  "block.minecraft.diamond_ore": "Diamantåre",
  "block.minecraft.diorite": "Dioritt",
  "block.minecraft.diorite_slab": "Helle av dioritt",
  "block.minecraft.diorite_stairs": "Trapp av dioritt",
  "block.minecraft.diorite_wall": "Mur av dioritt",
  "block.minecraft.dirt": "Jord",
  "block.minecraft.dirt_path": "Jordsti",
  "block.minecraft.dispenser": "Utskyter",
  "block.minecraft.dragon_egg": "Drageegg",
  "block.minecraft.dragon_head": "Dragehode",
  "block.minecraft.dragon_wall_head": "Dragevegghode",
  "block.minecraft.dried_ghast": "Uttørket ghast",
  "block.minecraft.dried_kelp_block": "Tørket tareblokk",
  "block.minecraft.dripstone_block": "Dryppsteinsblokk",
  "block.minecraft.dropper": "Utslipper",
  "block.minecraft.emerald_block": "Smaragdblokk",
  "block.minecraft.emerald_ore": "Smaragdåre",
  "block.minecraft.enchanting_table": "Trolldomsbord",
  "block.minecraft.end_gateway": "End-port",
  "block.minecraft.end_portal": "Endeportal",
  "block.minecraft.end_portal_frame": "End-portalramme",
  "block.minecraft.end_rod": "Endestang",
  "block.minecraft.end_stone": "Endestein",
  "block.minecraft.end_stone_brick_slab": "Helle av endesteinsmur",
  "block.minecraft.end_stone_brick_stairs": "Trapp av endesteinsmur",
  "block.minecraft.end_stone_brick_wall": "Mur av endesteinmur",
  "block.minecraft.end_stone_bricks": "Endesteinmur",
  "block.minecraft.ender_chest": "Enderkiste",
  "block.minecraft.exposed_chiseled_copper": "Utsatt uthugget kobber",
  "block.minecraft.exposed_copper": "Utsatt kobber",
  "block.minecraft.exposed_copper_bars": "Utsatt kobbergitter",
  "block.minecraft.exposed_copper_bulb": "Utsatt kobberpære",
  "block.minecraft.exposed_copper_chain": "Utsatt kobberkjetting",
  "block.minecraft.exposed_copper_chest": "Utsatt kobberkiste",
  "block.minecraft.exposed_copper_door": "Utsatt kobberdør",
  "block.minecraft.exposed_copper_golem_statue": "Utsatt kobbergubbestatue",
  "block.minecraft.exposed_copper_grate": "Utsatt kobberrist",
  "block.minecraft.exposed_copper_lantern": "Utsatt kobberlykt",
  "block.minecraft.exposed_copper_trapdoor": "Utsatt kobberfallem",
  "block.minecraft.exposed_cut_copper": "Utsatt skåret kobber",
  "block.minecraft.exposed_cut_copper_slab": "Helle av utsatt skåret kobber",
  "block.minecraft.exposed_cut_copper_stairs": "Trapp av utsatt skåret kobber",
  "block.minecraft.exposed_lightning_rod": "Utsatt lynavleder",
  "block.minecraft.farmland": "Dyrkbar mark",
  "block.minecraft.fern": "Bregne",
  "block.minecraft.fire": "Ild",
  "block.minecraft.fire_coral": "Ildkorall",
  "block.minecraft.fire_coral_block": "Ildkorallblokk",
  "block.minecraft.fire_coral_fan": "Ildkorallvifte",
  "block.minecraft.fire_coral_wall_fan": "Ildkorallveggvifte",
  "block.minecraft.firefly_bush": "Ildfluebusk",
  "block.minecraft.fletching_table": "Pilmakerbenk",
  "block.minecraft.flower_pot": "Blomsterpotte",
  "block.minecraft.flowering_azalea": "Blomstrende asalea",
  "block.minecraft.flowering_azalea_leaves": "Blomstrende asaleablader",
  "block.minecraft.frogspawn": "Froskerogn",
  "block.minecraft.frosted_ice": "Frostdekt Is",
  "block.minecraft.furnace": "Ovn",
  "block.minecraft.gilded_blackstone": "Forgyllet svartstein",
  "block.minecraft.glass": "Glass",
  "block.minecraft.glass_pane": "Glassrute",
  "block.minecraft.glow_lichen": "Glødelav",
  "block.minecraft.glowstone": "Glødestein",
  "block.minecraft.gold_block": "Gullblokk",
  "block.minecraft.gold_ore": "Gullåre",
  "block.minecraft.golden_dandelion": "Gyllen løvetann",
  "block.minecraft.granite": "Granitt",
  "block.minecraft.granite_slab": "Helle av granitt",
  "block.minecraft.granite_stairs": "Trapp av granitt",
  "block.minecraft.granite_wall": "Mur av granitt",
  "block.minecraft.grass": "Gress",
  "block.minecraft.grass_block": "Gressblokk",
  "block.minecraft.gravel": "Grus",
  "block.minecraft.gray_banner": "Grått banner",
  "block.minecraft.gray_bed": "Grå seng",
  "block.minecraft.gray_candle": "Grått vokslys",
  "block.minecraft.gray_candle_cake": "Kake med grått lys",
  "block.minecraft.gray_carpet": "Grått teppe",
  "block.minecraft.gray_concrete": "Grå betong",
  "block.minecraft.gray_concrete_powder": "Grå sement",
  "block.minecraft.gray_glazed_terracotta": "Grå glasert terrakotta",
  "block.minecraft.gray_shulker_box": "Grå shulkerboks",
  "block.minecraft.gray_stained_glass": "Grått farget glass",
  "block.minecraft.gray_stained_glass_pane": "Grå farget glassrute",
  "block.minecraft.gray_terracotta": "Grå terrakotta",
  "block.minecraft.gray_wool": "Grå ull",
  "block.minecraft.green_banner": "Grønt banner",
  "block.minecraft.green_bed": "Grønn seng",
  "block.minecraft.green_candle": "Grønt vokslys",
  "block.minecraft.green_candle_cake": "Kake med grønt lys",
  "block.minecraft.green_carpet": "Grønt teppe",
  "block.minecraft.green_concrete": "Grønn betong",
  "block.minecraft.green_concrete_powder": "Grønn sement",
  "block.minecraft.green_glazed_terracotta": "Grønn glasert terrakotta",
  "block.minecraft.green_shulker_box": "Grønn shulkerboks",
  "block.minecraft.green_stained_glass": "Grønt farget glass",
  "block.minecraft.green_stained_glass_pane": "Grønn farget glassrute",
  "block.minecraft.green_terracotta": "Grønn terrakotta",
  "block.minecraft.green_wool": "Grønn ull",
  "block.minecraft.grindstone": "Slipestein",
  "block.minecraft.hanging_roots": "Hengende røtter",
  "block.minecraft.hay_block": "Høyball",
  "block.minecraft.heavy_core": "Tung kjerne",
  "block.minecraft.heavy_weighted_pressure_plate": "Tung tyngdetrykkplate",
  "block.minecraft.honey_block": "Honningblokk",
  "block.minecraft.honeycomb_block": "Bikakeblokk",
  "block.minecraft.hopper": "Trakt",
  "block.minecraft.horn_coral": "Hornkorall",
  "block.minecraft.horn_coral_block": "Hornkorallblokk",
  "block.minecraft.horn_coral_fan": "Hornkorallvifte",
  "block.minecraft.horn_coral_wall_fan": "Hornkorallveggvifte",
  "block.minecraft.ice": "Is",
  "block.minecraft.infested_chiseled_stone_bricks": "Befengt uthugget steinmur",
  "block.minecraft.infested_cobblestone": "Befengt brostein",
  "block.minecraft.infested_cracked_stone_bricks": "Befengt sprukket steinmur",
  "block.minecraft.infested_deepslate": "Befengt dypskifer",
  "block.minecraft.infested_mossy_stone_bricks": "Befengt mosete steinmur",
  "block.minecraft.infested_stone": "Befengt stein",
  "block.minecraft.infested_stone_bricks": "Befengt steinmur",
  "block.minecraft.iron_bars": "Jerngitter",
  "block.minecraft.iron_block": "Jernblokk",
  "block.minecraft.iron_chain": "Jernkjetting",
  "block.minecraft.iron_door": "Jerndør",
  "block.minecraft.iron_ore": "Jernåre",
  "block.minecraft.iron_trapdoor": "Jernfallem",
  "block.minecraft.jack_o_lantern": "Gresskarlykt",
  "block.minecraft.jigsaw": "Pusleblokk",
  "block.minecraft.jukebox": "Platespiller",
  "block.minecraft.jungle_button": "Jungeltreknapp",
  "block.minecraft.jungle_door": "Jungeltredør",
  "block.minecraft.jungle_fence": "Jungeltregjerde",
  "block.minecraft.jungle_fence_gate": "Jungeltregrind",
  "block.minecraft.jungle_hanging_sign": "Hengende jungeltreskilt",
  "block.minecraft.jungle_leaves": "Jungeltreløv",
  "block.minecraft.jungle_log": "Jungeltretømmer",
  "block.minecraft.jungle_planks": "Jungeltreplanker",
  "block.minecraft.jungle_pressure_plate": "Jungeltretrykkplate",
  "block.minecraft.jungle_sapling": "Jungeltrespire",
  "block.minecraft.jungle_shelf": "Jungeltrehylle",
  "block.minecraft.jungle_sign": "Jungeltreskilt",
  "block.minecraft.jungle_slab": "Jungeltrehelle",
  "block.minecraft.jungle_stairs": "Jungeltretrapp",
  "block.minecraft.jungle_trapdoor": "Jungeltrefallem",
  "block.minecraft.jungle_wall_hanging_sign": "Vegghengende jungeltreskilt",
  "block.minecraft.jungle_wall_sign": "Jungeltreveggskilt",
  "block.minecraft.jungle_wood": "Jungeltre",
  "block.minecraft.kelp": "Tare",
  "block.minecraft.kelp_plant": "Tareplante",
  "block.minecraft.ladder": "Stige",
  "block.minecraft.lantern": "Lykt",
  "block.minecraft.lapis_block": "Lasursteinblokk",
  "block.minecraft.lapis_ore": "Lasursteinåre",
  "block.minecraft.large_amethyst_bud": "Stor ametystknopp",
  "block.minecraft.large_fern": "Stor bregne",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Gryte med lava",
  "block.minecraft.leaf_litter": "Strødde løv",
  "block.minecraft.lectern": "Lesepult",
  "block.minecraft.lever": "Spak",
  "block.minecraft.light": "Lys",
  "block.minecraft.light_blue_banner": "Lyseblått banner",
  "block.minecraft.light_blue_bed": "Lyseblå seng",
  "block.minecraft.light_blue_candle": "Lyseblått vokslys",
  "block.minecraft.light_blue_candle_cake": "Kake med lyseblått lys",
  "block.minecraft.light_blue_carpet": "Lyseblått teppe",
  "block.minecraft.light_blue_concrete": "Lyseblå betong",
  "block.minecraft.light_blue_concrete_powder": "Lyseblå sement",
  "block.minecraft.light_blue_glazed_terracotta": "Lyseblå glasert terrakotta",
  "block.minecraft.light_blue_shulker_box": "Lyseblå shulkerboks",
  "block.minecraft.light_blue_stained_glass": "Lyseblått farget glass",
  "block.minecraft.light_blue_stained_glass_pane": "Lyseblå farget glassrute",
  "block.minecraft.light_blue_terracotta": "Lyseblå terrakotta",
  "block.minecraft.light_blue_wool": "Lyseblå ull",
  "block.minecraft.light_gray_banner": "Lysegrått banner",
  "block.minecraft.light_gray_bed": "Lysegrå seng",
  "block.minecraft.light_gray_candle": "Lysegrått vokslys",
  "block.minecraft.light_gray_candle_cake": "Kake med lysegrått lys",
  "block.minecraft.light_gray_carpet": "Lysegrått teppe",
  "block.minecraft.light_gray_concrete": "Lysegrå betong",
  "block.minecraft.light_gray_concrete_powder": "Lysegrå sement",
  "block.minecraft.light_gray_glazed_terracotta": "Lysegrå glasert terrakotta",
  "block.minecraft.light_gray_shulker_box": "Lysegrå shulkerboks",
  "block.minecraft.light_gray_stained_glass": "Lysegrått farget glass",
  "block.minecraft.light_gray_stained_glass_pane": "Lysegrå farget glassrute",
  "block.minecraft.light_gray_terracotta": "Lysegrå terrakotta",
  "block.minecraft.light_gray_wool": "Lysegrå ull",
  "block.minecraft.light_weighted_pressure_plate": "Lett tyngdetrykkplate",
  "block.minecraft.lightning_rod": "Lynavleder",
  "block.minecraft.lilac": "Syrin",
  "block.minecraft.lily_of_the_valley": "Liljekonvall",
  "block.minecraft.lily_pad": "Vannliljeblad",
  "block.minecraft.lime_banner": "Limegrønt banner",
  "block.minecraft.lime_bed": "Limegrønn seng",
  "block.minecraft.lime_candle": "Limegrønt vokslys",
  "block.minecraft.lime_candle_cake": "Kake med limegrønt lys",
  "block.minecraft.lime_carpet": "Limegrønt teppe",
  "block.minecraft.lime_concrete": "Limegrønn betong",
  "block.minecraft.lime_concrete_powder": "Limegrønn sement",
  "block.minecraft.lime_glazed_terracotta": "Limegrønn glasert terrakotta",
  "block.minecraft.lime_shulker_box": "Limegrønn shulkerboks",
  "block.minecraft.lime_stained_glass": "Limegrønt farget glass",
  "block.minecraft.lime_stained_glass_pane": "Limegrønn farget glassrute",
  "block.minecraft.lime_terracotta": "Limegrønn terrakotta",
  "block.minecraft.lime_wool": "Limegrønn ull",
  "block.minecraft.lodestone": "Leidarstein",
  "block.minecraft.loom": "Vevstol",
  "block.minecraft.magenta_banner": "Magenta banner",
  "block.minecraft.magenta_bed": "Magenta seng",
  "block.minecraft.magenta_candle": "Magenta vokslys",
  "block.minecraft.magenta_candle_cake": "Kake med magenta lys",
  "block.minecraft.magenta_carpet": "Magenta teppe",
  "block.minecraft.magenta_concrete": "Magenta betong",
  "block.minecraft.magenta_concrete_powder": "Magenta sement",
  "block.minecraft.magenta_glazed_terracotta": "Magenta glasert terrakotta",
  "block.minecraft.magenta_shulker_box": "Magenta shulkerboks",
  "block.minecraft.magenta_stained_glass": "Magenta farget glass",
  "block.minecraft.magenta_stained_glass_pane": "Magenta farget glassrute",
  "block.minecraft.magenta_terracotta": "Magenta terrakotta",
  "block.minecraft.magenta_wool": "Magenta ull",
  "block.minecraft.magma_block": "Magmablokk",
  "block.minecraft.mangrove_button": "Mangroveknapp",
  "block.minecraft.mangrove_door": "Mangrovedør",
  "block.minecraft.mangrove_fence": "Mangrovegjerde",
  "block.minecraft.mangrove_fence_gate": "Mangrovegrind",
  "block.minecraft.mangrove_hanging_sign": "Hengende mangroveskilt",
  "block.minecraft.mangrove_leaves": "Mangroveblader",
  "block.minecraft.mangrove_log": "Mangrovetømmer",
  "block.minecraft.mangrove_planks": "Mangroveplanker",
  "block.minecraft.mangrove_pressure_plate": "Mangrovetrykkplate",
  "block.minecraft.mangrove_propagule": "Mangrovebulbill",
  "block.minecraft.mangrove_roots": "Mangroverøtter",
  "block.minecraft.mangrove_shelf": "Mangrovehylle",
  "block.minecraft.mangrove_sign": "Mangroveskilt",
  "block.minecraft.mangrove_slab": "Mangrovehelle",
  "block.minecraft.mangrove_stairs": "Mangrovetrapp",
  "block.minecraft.mangrove_trapdoor": "Mangrovefallem",
  "block.minecraft.mangrove_wall_hanging_sign": "Vegghengende mangroveskilt",
  "block.minecraft.mangrove_wall_sign": "Mangroveveggskilt",
  "block.minecraft.mangrove_wood": "Mangrovetre",
  "block.minecraft.medium_amethyst_bud": "Mellomstor ametystknopp",
  "block.minecraft.melon": "Melon",
  "block.minecraft.melon_stem": "Melonstilk",
  "block.minecraft.moss_block": "Moseblokk",
  "block.minecraft.moss_carpet": "Moseteppe",
  "block.minecraft.mossy_cobblestone": "Mosete brostein",
  "block.minecraft.mossy_cobblestone_slab": "Helle av mosete brostein",
  "block.minecraft.mossy_cobblestone_stairs": "Trapp av mosete brostein",
  "block.minecraft.mossy_cobblestone_wall": "Mur av mosete brostein",
  "block.minecraft.mossy_stone_brick_slab": "Helle av mosete steinmur",
  "block.minecraft.mossy_stone_brick_stairs": "Trapp av mosete steinmur",
  "block.minecraft.mossy_stone_brick_wall": "Mur av mosete steinmur",
  "block.minecraft.mossy_stone_bricks": "Mosete steinmur",
  "block.minecraft.moving_piston": "Bevegende stempel",
  "block.minecraft.mud": "Gjørme",
  "block.minecraft.mud_brick_slab": "Helle av gjørmetegl",
  "block.minecraft.mud_brick_stairs": "Trapp av gjørmetegl",
  "block.minecraft.mud_brick_wall": "Mur av gjørmetegl",
  "block.minecraft.mud_bricks": "Gjørmetegl",
  "block.minecraft.muddy_mangrove_roots": "Gjørmete mangroverøtter",
  "block.minecraft.mushroom_stem": "Soppstilk",
  "block.minecraft.mycelium": "Mycel",
  "block.minecraft.nether_brick_fence": "Gjerde av nethertegl",
  "block.minecraft.nether_brick_slab": "Helle av nethertegl",
  "block.minecraft.nether_brick_stairs": "Trapp av nethertegl",
  "block.minecraft.nether_brick_wall": "Mur av nethertegl",
  "block.minecraft.nether_bricks": "Nethertegl",
  "block.minecraft.nether_gold_ore": "Nethergullåre",
  "block.minecraft.nether_portal": "Netherportal",
  "block.minecraft.nether_quartz_ore": "Netherkvartsåre",
  "block.minecraft.nether_sprouts": "Netherspirer",
  "block.minecraft.nether_wart": "Nethervorte",
  "block.minecraft.nether_wart_block": "Nethervorteblokk",
  "block.minecraft.netherite_block": "Netherittblokk",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Noteblokk",
  "block.minecraft.oak_button": "Eikeknapp",
  "block.minecraft.oak_door": "Eikedør",
  "block.minecraft.oak_fence": "Eikegjerde",
  "block.minecraft.oak_fence_gate": "Eikegrind",
  "block.minecraft.oak_hanging_sign": "Hengende eikeskilt",
  "block.minecraft.oak_leaves": "Eikeløv",
  "block.minecraft.oak_log": "Eiketømmer",
  "block.minecraft.oak_planks": "Eikeplanker",
  "block.minecraft.oak_pressure_plate": "Eiketrykkplate",
  "block.minecraft.oak_sapling": "Eikespire",
  "block.minecraft.oak_shelf": "Eikehylle",
  "block.minecraft.oak_sign": "Eikeskilt",
  "block.minecraft.oak_slab": "Eikehelle",
  "block.minecraft.oak_stairs": "Eiketrapp",
  "block.minecraft.oak_trapdoor": "Eikefallem",
  "block.minecraft.oak_wall_hanging_sign": "Vegghengende eikeskilt",
  "block.minecraft.oak_wall_sign": "Eikeveggskilt",
  "block.minecraft.oak_wood": "Eiketre",
  "block.minecraft.observer": "Observatør",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Okert froskelys",
  "block.minecraft.ominous_banner": "Illevarslende fane",
  "block.minecraft.open_eyeblossom": "Åpen øyeblom",
  "block.minecraft.orange_banner": "Oransje banner",
  "block.minecraft.orange_bed": "Oransje seng",
  "block.minecraft.orange_candle": "Oransje vokslys",
  "block.minecraft.orange_candle_cake": "Kake med oransje lys",
  "block.minecraft.orange_carpet": "Oransje teppe",
  "block.minecraft.orange_concrete": "Oransje betong",
  "block.minecraft.orange_concrete_powder": "Oransje sement",
  "block.minecraft.orange_glazed_terracotta": "Oransje glasert terrakotta",
  "block.minecraft.orange_shulker_box": "Oransje shulkerboks",
  "block.minecraft.orange_stained_glass": "Oransje farget glass",
  "block.minecraft.orange_stained_glass_pane": "Oransje farget glassrute",
  "block.minecraft.orange_terracotta": "Oransje terrakotta",
  "block.minecraft.orange_tulip": "Oransje tulipan",
  "block.minecraft.orange_wool": "Oransje ull",
  "block.minecraft.oxeye_daisy": "Prestekrage",
  "block.minecraft.oxidized_chiseled_copper": "Irret uthugget kobber",
  "block.minecraft.oxidized_copper": "Irret kobber",
  "block.minecraft.oxidized_copper_bars": "Irret kobbergitter",
  "block.minecraft.oxidized_copper_bulb": "Irret kobberpære",
  "block.minecraft.oxidized_copper_chain": "Irret kobberkjetting",
  "block.minecraft.oxidized_copper_chest": "Irret kobberkiste",
  "block.minecraft.oxidized_copper_door": "Irret kobberdør",
  "block.minecraft.oxidized_copper_golem_statue": "Irret kobbergubbestatue",
  "block.minecraft.oxidized_copper_grate": "Irret kobberrist",
  "block.minecraft.oxidized_copper_lantern": "Irret kobberlykt",
  "block.minecraft.oxidized_copper_trapdoor": "Irret kobberfallem",
  "block.minecraft.oxidized_cut_copper": "Irret skåret kobber",
  "block.minecraft.oxidized_cut_copper_slab": "Helle av irret skåret kobber",
  "block.minecraft.oxidized_cut_copper_stairs": "Trapp av irret skåret kobber",
  "block.minecraft.oxidized_lightning_rod": "Irret lynavleder",
  "block.minecraft.packed_ice": "Tettpakket is",
  "block.minecraft.packed_mud": "Stråbunden gjørme",
  "block.minecraft.pale_hanging_moss": "Hengende tåkemose",
  "block.minecraft.pale_moss_block": "Tåkemoseblokk",
  "block.minecraft.pale_moss_carpet": "Tåkemoseteppe",
  "block.minecraft.pale_oak_button": "Blekeikeknapp",
  "block.minecraft.pale_oak_door": "Blekeikedør",
  "block.minecraft.pale_oak_fence": "Blekeikegjerde",
  "block.minecraft.pale_oak_fence_gate": "Blekeikegrind",
  "block.minecraft.pale_oak_hanging_sign": "Hengende blekeikeskilt",
  "block.minecraft.pale_oak_leaves": "Blekeikeløv",
  "block.minecraft.pale_oak_log": "Blekeiketømmer",
  "block.minecraft.pale_oak_planks": "Blekeikeplanker",
  "block.minecraft.pale_oak_pressure_plate": "Blekeiketrykkplate",
  "block.minecraft.pale_oak_sapling": "Blekeikespire",
  "block.minecraft.pale_oak_shelf": "Blekeikehylle",
  "block.minecraft.pale_oak_sign": "Blekeikeskilt",
  "block.minecraft.pale_oak_slab": "Blekeikehelle",
  "block.minecraft.pale_oak_stairs": "Blekeiketrapp",
  "block.minecraft.pale_oak_trapdoor": "Blekeikefallem",
  "block.minecraft.pale_oak_wall_hanging_sign": "Vegghengende blekeikeskilt",
  "block.minecraft.pale_oak_wall_sign": "Blekeikeveggskilt",
  "block.minecraft.pale_oak_wood": "Blekeiketre",
  "block.minecraft.pearlescent_froglight": "Perleskimrende froskelys",
  "block.minecraft.peony": "Peon",
  "block.minecraft.petrified_oak_slab": "Helle av forsteinet eik",
  "block.minecraft.piglin_head": "Piglinhode",
  "block.minecraft.piglin_wall_head": "Piglinvegghode",
  "block.minecraft.pink_banner": "Rosa banner",
  "block.minecraft.pink_bed": "Rosa seng",
  "block.minecraft.pink_candle": "Rosa vokslys",
  "block.minecraft.pink_candle_cake": "Kake med rosa lys",
  "block.minecraft.pink_carpet": "Rosa teppe",
  "block.minecraft.pink_concrete": "Rosa betong",
  "block.minecraft.pink_concrete_powder": "Rosa sement",
  "block.minecraft.pink_glazed_terracotta": "Rosa glasert terrakotta",
  "block.minecraft.pink_petals": "Rosa kronblader",
  "block.minecraft.pink_shulker_box": "Rosa shulkerboks",
  "block.minecraft.pink_stained_glass": "Rosa farget glass",
  "block.minecraft.pink_stained_glass_pane": "Rosa farget glassrute",
  "block.minecraft.pink_terracotta": "Rosa terrakotta",
  "block.minecraft.pink_tulip": "Rosa tulipan",
  "block.minecraft.pink_wool": "Rosa ull",
  "block.minecraft.piston": "Stempel",
  "block.minecraft.piston_head": "Stempelhode",
  "block.minecraft.pitcher_crop": "Kanneplantebelg",
  "block.minecraft.pitcher_plant": "Kanneplante",
  "block.minecraft.player_head": "Spillerhode",
  "block.minecraft.player_head.named": "%ss hode",
  "block.minecraft.player_wall_head": "Spillervegghode",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Spiss dryppstein",
  "block.minecraft.polished_andesite": "Finslipt andesitt",
  "block.minecraft.polished_andesite_slab": "Helle av finslipt andesitt",
  "block.minecraft.polished_andesite_stairs": "Trapp av finslipt andesitt",
  "block.minecraft.polished_basalt": "Finslipt basalt",
  "block.minecraft.polished_blackstone": "Finslipt svartstein",
  "block.minecraft.polished_blackstone_brick_slab": "Helle av finslipt svartsteinsmur",
  "block.minecraft.polished_blackstone_brick_stairs": "Trapp av finslipt svartsteinsmur",
  "block.minecraft.polished_blackstone_brick_wall": "Mur av finslipt svartsteinsmur",
  "block.minecraft.polished_blackstone_bricks": "Finslipt svartsteinsmur",
  "block.minecraft.polished_blackstone_button": "Knapp av finslipt svartstein",
  "block.minecraft.polished_blackstone_pressure_plate": "Trykkplate av finslipt svartstein",
  "block.minecraft.polished_blackstone_slab": "Helle av finslipt svartstein",
  "block.minecraft.polished_blackstone_stairs": "Trapp av finslipt svartstein",
  "block.minecraft.polished_blackstone_wall": "Mur av finslipt svartstein",
  "block.minecraft.polished_deepslate": "Finpusset dypskifer",
  "block.minecraft.polished_deepslate_slab": "Helle av finpusset dypskifer",
  "block.minecraft.polished_deepslate_stairs": "Trapp av finpusset dypskifer",
  "block.minecraft.polished_deepslate_wall": "Mur av finpusset dypskifer",
  "block.minecraft.polished_diorite": "Finslipt dioritt",
  "block.minecraft.polished_diorite_slab": "Helle av finslipt dioritt",
  "block.minecraft.polished_diorite_stairs": "Trapp av finslipt dioritt",
  "block.minecraft.polished_granite": "Finslipt granitt",
  "block.minecraft.polished_granite_slab": "Helle av finslipt granitt",
  "block.minecraft.polished_granite_stairs": "Trapp av finslipt granitt",
  "block.minecraft.polished_tuff": "Finslipt tuffstein",
  "block.minecraft.polished_tuff_slab": "Helle av finslipt tuffstein",
  "block.minecraft.polished_tuff_stairs": "Trapp av finslipt tuffstein",
  "block.minecraft.polished_tuff_wall": "Mur av finslipt tuffstein",
  "block.minecraft.poppy": "Valmue",
  "block.minecraft.potatoes": "Poteter",
  "block.minecraft.potted_acacia_sapling": "Akasiespire i potte",
  "block.minecraft.potted_allium": "Prydløk i potte",
  "block.minecraft.potted_azalea_bush": "Asalea i potte",
  "block.minecraft.potted_azure_bluet": "Houstonia caerulea i potte",
  "block.minecraft.potted_bamboo": "Bambus i potte",
  "block.minecraft.potted_birch_sapling": "Bjørkespire i potte",
  "block.minecraft.potted_blue_orchid": "Blå orkidé i potte",
  "block.minecraft.potted_brown_mushroom": "Brun sopp i potte",
  "block.minecraft.potted_cactus": "Kaktus i potte",
  "block.minecraft.potted_cherry_sapling": "Kirsebærspire i potte",
  "block.minecraft.potted_closed_eyeblossom": "Lukket øyeblom i potte",
  "block.minecraft.potted_cornflower": "Kornblost i potte",
  "block.minecraft.potted_crimson_fungus": "Karmosinsopp i potte",
  "block.minecraft.potted_crimson_roots": "Karmosinrøtter i potte",
  "block.minecraft.potted_dandelion": "Løvetann i potte",
  "block.minecraft.potted_dark_oak_sapling": "Mørkeikespire i potte",
  "block.minecraft.potted_dead_bush": "Død busk i potte",
  "block.minecraft.potted_fern": "Bregne i potte",
  "block.minecraft.potted_flowering_azalea_bush": "Blomstrende asalea i potte",
  "block.minecraft.potted_golden_dandelion": "Gyllen løvetann i potte",
  "block.minecraft.potted_jungle_sapling": "Jungeltrespire i potte",
  "block.minecraft.potted_lily_of_the_valley": "Liljekonvall i potte",
  "block.minecraft.potted_mangrove_propagule": "Mangrovebulbill i potte",
  "block.minecraft.potted_oak_sapling": "Eikespire i potte",
  "block.minecraft.potted_open_eyeblossom": "Åpen øyeblom i potte",
  "block.minecraft.potted_orange_tulip": "Oransje tulipan i potte",
  "block.minecraft.potted_oxeye_daisy": "Prestekrage i potte",
  "block.minecraft.potted_pale_oak_sapling": "Blekeikespire i potte",
  "block.minecraft.potted_pink_tulip": "Rosa tulipan i potte",
  "block.minecraft.potted_poppy": "Valmue i potte",
  "block.minecraft.potted_red_mushroom": "Rød sopp i potte",
  "block.minecraft.potted_red_tulip": "Rød tulipan i potte",
  "block.minecraft.potted_spruce_sapling": "Granspire i potte",
  "block.minecraft.potted_torchflower": "Fakkelblomst i potte",
  "block.minecraft.potted_warped_fungus": "Forvridd sopp i potte",
  "block.minecraft.potted_warped_roots": "Forvridde røtter i potte",
  "block.minecraft.potted_white_tulip": "Hvit tulipan i potte",
  "block.minecraft.potted_wither_rose": "Witherrose i potte",
  "block.minecraft.powder_snow": "Puddersnø",
  "block.minecraft.powder_snow_cauldron": "Gryte med snø",
  "block.minecraft.powered_rail": "Redstonedrevet skinne",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Helle av prismarinmur",
  "block.minecraft.prismarine_brick_stairs": "Trapp av prismarinmur",
  "block.minecraft.prismarine_bricks": "Prismarinmur",
  "block.minecraft.prismarine_slab": "Helle av prismarin",
  "block.minecraft.prismarine_stairs": "Trapp av prismarin",
  "block.minecraft.prismarine_wall": "Mur av prismarin",
  "block.minecraft.pumpkin": "Gresskar",
  "block.minecraft.pumpkin_stem": "Gresskarstilk",
  "block.minecraft.purple_banner": "Lilla banner",
  "block.minecraft.purple_bed": "Lilla seng",
  "block.minecraft.purple_candle": "Lilla vokslys",
  "block.minecraft.purple_candle_cake": "Kake med lilla lys",
  "block.minecraft.purple_carpet": "Lilla teppe",
  "block.minecraft.purple_concrete": "Lilla betong",
  "block.minecraft.purple_concrete_powder": "Lilla sement",
  "block.minecraft.purple_glazed_terracotta": "Lilla glasert terrakotta",
  "block.minecraft.purple_shulker_box": "Lilla shulkerboks",
  "block.minecraft.purple_stained_glass": "Lilla farget glass",
  "block.minecraft.purple_stained_glass_pane": "Lilla farget glassrute",
  "block.minecraft.purple_terracotta": "Lilla terrakotta",
  "block.minecraft.purple_wool": "Lilla ull",
  "block.minecraft.purpur_block": "Purpurblokk",
  "block.minecraft.purpur_pillar": "Purpursøyle",
  "block.minecraft.purpur_slab": "Helle av purpur",
  "block.minecraft.purpur_stairs": "Trapp av purpur",
  "block.minecraft.quartz_block": "Kvartsblokk",
  "block.minecraft.quartz_bricks": "Kvartsmur",
  "block.minecraft.quartz_pillar": "Kvartssøyle",
  "block.minecraft.quartz_slab": "Helle av kvarts",
  "block.minecraft.quartz_stairs": "Trapp av kvarts",
  "block.minecraft.rail": "Skinne",
  "block.minecraft.raw_copper_block": "Blokk av kobbermalm",
  "block.minecraft.raw_gold_block": "Blokk av gullmalm",
  "block.minecraft.raw_iron_block": "Blokk av jernmalm",
  "block.minecraft.red_banner": "Rødt banner",
  "block.minecraft.red_bed": "Rød seng",
  "block.minecraft.red_candle": "Rødt vokslys",
  "block.minecraft.red_candle_cake": "Kake med rødt lys",
  "block.minecraft.red_carpet": "Rødt teppe",
  "block.minecraft.red_concrete": "Rød betong",
  "block.minecraft.red_concrete_powder": "Rød sement",
  "block.minecraft.red_glazed_terracotta": "Rød glasert terrakotta",
  "block.minecraft.red_mushroom": "Rød sopp",
  "block.minecraft.red_mushroom_block": "Rød soppblokk",
  "block.minecraft.red_nether_brick_slab": "Helle av rødt nethertegl",
  "block.minecraft.red_nether_brick_stairs": "Trapp av rødt nethertegl",
  "block.minecraft.red_nether_brick_wall": "Mur av rødt nethertegl",
  "block.minecraft.red_nether_bricks": "Rødt nethertegl",
  "block.minecraft.red_sand": "Rød sand",
  "block.minecraft.red_sandstone": "Rød sandstein",
  "block.minecraft.red_sandstone_slab": "Helle av rød sandstein",
  "block.minecraft.red_sandstone_stairs": "Trapp av rød sandstein",
  "block.minecraft.red_sandstone_wall": "Mur av rød sandstein",
  "block.minecraft.red_shulker_box": "Rød shulkerboks",
  "block.minecraft.red_stained_glass": "Rødt farget glass",
  "block.minecraft.red_stained_glass_pane": "Rød farget glassrute",
  "block.minecraft.red_terracotta": "Rød terrakotta",
  "block.minecraft.red_tulip": "Rød tulipan",
  "block.minecraft.red_wool": "Rød ull",
  "block.minecraft.redstone_block": "Redstoneblokk",
  "block.minecraft.redstone_lamp": "Redstonelampe",
  "block.minecraft.redstone_ore": "Redstoneåre",
  "block.minecraft.redstone_torch": "Redstonefakkel",
  "block.minecraft.redstone_wall_torch": "Redstoneveggfakkel",
  "block.minecraft.redstone_wire": "Redstonespor",
  "block.minecraft.reinforced_deepslate": "Herdet dypskifer",
  "block.minecraft.repeater": "Redstoneforsterker",
  "block.minecraft.repeating_command_block": "Repeterende kommandoblokk",
  "block.minecraft.resin_block": "Kvaeblokk",
  "block.minecraft.resin_brick_slab": "Helle av kvaetegl",
  "block.minecraft.resin_brick_stairs": "Trapp av kvaetegl",
  "block.minecraft.resin_brick_wall": "Mur av kvaetegl",
  "block.minecraft.resin_bricks": "Kvaetegl",
  "block.minecraft.resin_clump": "Kvaeklump",
  "block.minecraft.respawn_anchor": "Livsanker",
  "block.minecraft.rooted_dirt": "Rotjord",
  "block.minecraft.rose_bush": "Rosebusk",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandstein",
  "block.minecraft.sandstone_slab": "Helle av sandstein",
  "block.minecraft.sandstone_stairs": "Trapp av sandstein",
  "block.minecraft.sandstone_wall": "Mur av sandstein",
  "block.minecraft.scaffolding": "Stillas",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkkatalysator",
  "block.minecraft.sculk_sensor": "Sculksensor",
  "block.minecraft.sculk_shrieker": "Sculkskriker",
  "block.minecraft.sculk_vein": "Sculkåre",
  "block.minecraft.sea_lantern": "Sjølanterne",
  "block.minecraft.sea_pickle": "Sjøagurk",
  "block.minecraft.seagrass": "Sjøgress",
  "block.minecraft.set_spawn": "Startpunkt satt",
  "block.minecraft.short_dry_grass": "Kort tørt gress",
  "block.minecraft.short_grass": "Kort gress",
  "block.minecraft.shroomlight": "Lampinjong",
  "block.minecraft.shulker_box": "Shulkerboks",
  "block.minecraft.skeleton_skull": "Skjelettskalle",
  "block.minecraft.skeleton_wall_skull": "Skjelettveggskalle",
  "block.minecraft.slime_block": "Slimblokk",
  "block.minecraft.small_amethyst_bud": "Liten ametystknopp",
  "block.minecraft.small_dripleaf": "Lite dråpeblad",
  "block.minecraft.smithing_table": "Smibenk",
  "block.minecraft.smoker": "Røykovn",
  "block.minecraft.smooth_basalt": "Jevn basalt",
  "block.minecraft.smooth_quartz": "Jevn kvartsblokk",
  "block.minecraft.smooth_quartz_slab": "Helle av jevn kvarts",
  "block.minecraft.smooth_quartz_stairs": "Trapp av jevn kvarts",
  "block.minecraft.smooth_red_sandstone": "Jevn rød sandstein",
  "block.minecraft.smooth_red_sandstone_slab": "Helle av jevn rød sandstein",
  "block.minecraft.smooth_red_sandstone_stairs": "Trapp av jevn rød sandstein",
  "block.minecraft.smooth_sandstone": "Jevn sandstein",
  "block.minecraft.smooth_sandstone_slab": "Helle av jevn sandstein",
  "block.minecraft.smooth_sandstone_stairs": "Trapp av jevn sandstein",
  "block.minecraft.smooth_stone": "Jevn stein",
  "block.minecraft.smooth_stone_slab": "Helle av jevn stein",
  "block.minecraft.sniffer_egg": "Snufseregg",
  "block.minecraft.snow": "Snø",
  "block.minecraft.snow_block": "Snøblokk",
  "block.minecraft.soul_campfire": "Sjelebål",
  "block.minecraft.soul_fire": "Sjeleild",
  "block.minecraft.soul_lantern": "Sjelelykt",
  "block.minecraft.soul_sand": "Sjelesand",
  "block.minecraft.soul_soil": "Sjelejord",
  "block.minecraft.soul_torch": "Sjelefakkel",
  "block.minecraft.soul_wall_torch": "Sjeleveggfakkel",
  "block.minecraft.spawn.not_valid": "Enten har du ingen seng eller noe ladet livsanker, eller så var noe i veien",
  "block.minecraft.spawner": "Skapningsmaner",
  "block.minecraft.spawner.desc1": "Benytt fremkallingsegg:",
  "block.minecraft.spawner.desc2": "Setter skapningstype",
  "block.minecraft.sponge": "Svamp",
  "block.minecraft.spore_blossom": "Moseblomst",
  "block.minecraft.spruce_button": "Granknapp",
  "block.minecraft.spruce_door": "Grandør",
  "block.minecraft.spruce_fence": "Grangjerde",
  "block.minecraft.spruce_fence_gate": "Grangrind",
  "block.minecraft.spruce_hanging_sign": "Hengende granskilt",
  "block.minecraft.spruce_leaves": "Granbar",
  "block.minecraft.spruce_log": "Grantømmer",
  "block.minecraft.spruce_planks": "Granplanker",
  "block.minecraft.spruce_pressure_plate": "Grantrykkplate",
  "block.minecraft.spruce_sapling": "Granspire",
  "block.minecraft.spruce_shelf": "Granhylle",
  "block.minecraft.spruce_sign": "Granskilt",
  "block.minecraft.spruce_slab": "Granhelle",
  "block.minecraft.spruce_stairs": "Grantrapp",
  "block.minecraft.spruce_trapdoor": "Granfallem",
  "block.minecraft.spruce_wall_hanging_sign": "Vegghengende granskilt",
  "block.minecraft.spruce_wall_sign": "Granveggskilt",
  "block.minecraft.spruce_wood": "Grantre",
  "block.minecraft.sticky_piston": "Klebrig stempel",
  "block.minecraft.stone": "Stein",
  "block.minecraft.stone_brick_slab": "Helle av steinmur",
  "block.minecraft.stone_brick_stairs": "Trapp av steinmur",
  "block.minecraft.stone_brick_wall": "Mur av steinmur",
  "block.minecraft.stone_bricks": "Steinmur",
  "block.minecraft.stone_button": "Steinknapp",
  "block.minecraft.stone_pressure_plate": "Steintrykkplate",
  "block.minecraft.stone_slab": "Helle av stein",
  "block.minecraft.stone_stairs": "Trapp av stein",
  "block.minecraft.stonecutter": "Steinkutter",
  "block.minecraft.stripped_acacia_log": "Slindet akasietømmer",
  "block.minecraft.stripped_acacia_wood": "Slindet akasietre",
  "block.minecraft.stripped_bamboo_block": "Slindet bambusblokk",
  "block.minecraft.stripped_birch_log": "Slindet bjørketømmer",
  "block.minecraft.stripped_birch_wood": "Slindet bjørketre",
  "block.minecraft.stripped_cherry_log": "Slindet kirsebærtømmer",
  "block.minecraft.stripped_cherry_wood": "Slindet kirsebærtre",
  "block.minecraft.stripped_crimson_hyphae": "Slindet karmosinhyfe",
  "block.minecraft.stripped_crimson_stem": "Slindet karmosinstilk",
  "block.minecraft.stripped_dark_oak_log": "Slindet mørkeiketømmer",
  "block.minecraft.stripped_dark_oak_wood": "Slindet mørkeiketre",
  "block.minecraft.stripped_jungle_log": "Slindet jungeltretømmer",
  "block.minecraft.stripped_jungle_wood": "Slindet jungeltre",
  "block.minecraft.stripped_mangrove_log": "Slindet mangrovetømmer",
  "block.minecraft.stripped_mangrove_wood": "Slindet mangrovetre",
  "block.minecraft.stripped_oak_log": "Slindet eiketømmer",
  "block.minecraft.stripped_oak_wood": "Slindet eiketre",
  "block.minecraft.stripped_pale_oak_log": "Slindet blekeiketømmer",
  "block.minecraft.stripped_pale_oak_wood": "Slindet blekeiketre",
  "block.minecraft.stripped_spruce_log": "Slindet grantømmer",
  "block.minecraft.stripped_spruce_wood": "Slindet grantre",
  "block.minecraft.stripped_warped_hyphae": "Slindet forvridd hyfe",
  "block.minecraft.stripped_warped_stem": "Slindet forvridd stilk",
  "block.minecraft.structure_block": "Strukturblokk",
  "block.minecraft.structure_void": "Struktur-tomrom",
  "block.minecraft.sugar_cane": "Sukkerrør",
  "block.minecraft.sunflower": "Solsikke",
  "block.minecraft.suspicious_gravel": "Mistenkelig grus",
  "block.minecraft.suspicious_sand": "Mistenkelig sand",
  "block.minecraft.sweet_berry_bush": "Søtbærbusk",
  "block.minecraft.tall_dry_grass": "Langt tørt gress",
  "block.minecraft.tall_grass": "Høyt gress",
  "block.minecraft.tall_seagrass": "Høyt sjøgress",
  "block.minecraft.target": "Blink",
  "block.minecraft.terracotta": "Terrakotta",
  "block.minecraft.test_block": "Testblokk",
  "block.minecraft.test_instance_block": "Testinstanseblokk",
  "block.minecraft.tinted_glass": "Sotet glass",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT-eksplosjoner er slått av",
  "block.minecraft.torch": "Fakkel",
  "block.minecraft.torchflower": "Fakkelblomst",
  "block.minecraft.torchflower_crop": "Fakkelblomstavling",
  "block.minecraft.trapped_chest": "Utløserkiste",
  "block.minecraft.trial_spawner": "Prøvelsesfremkaller",
  "block.minecraft.tripwire": "Snubletråd",
  "block.minecraft.tripwire_hook": "Snubletrådkrok",
  "block.minecraft.tube_coral": "Orgelkorall",
  "block.minecraft.tube_coral_block": "Orgelkorallblokk",
  "block.minecraft.tube_coral_fan": "Orgelkorallvifte",
  "block.minecraft.tube_coral_wall_fan": "Orgelkorallveggvifte",
  "block.minecraft.tuff": "Tuffstein",
  "block.minecraft.tuff_brick_slab": "Helle av tuffsteintegl",
  "block.minecraft.tuff_brick_stairs": "Trapp av tuffsteintegl",
  "block.minecraft.tuff_brick_wall": "Mur av tuffsteintegl",
  "block.minecraft.tuff_bricks": "Tuffsteintegl",
  "block.minecraft.tuff_slab": "Helle av tuffstein",
  "block.minecraft.tuff_stairs": "Trapp av tuffstein",
  "block.minecraft.tuff_wall": "Mur av tuffstein",
  "block.minecraft.turtle_egg": "Skilpaddeegg",
  "block.minecraft.twisting_vines": "Vridvin",
  "block.minecraft.twisting_vines_plant": "Vridvin",
  "block.minecraft.vault": "Hvelv",
  "block.minecraft.verdant_froglight": "Ferskt froskelys",
  "block.minecraft.vine": "Ranke",
  "block.minecraft.void_air": "Tomrom",
  "block.minecraft.wall_torch": "Veggfakkel",
  "block.minecraft.warped_button": "Forvridd knapp",
  "block.minecraft.warped_door": "Forvridd dør",
  "block.minecraft.warped_fence": "Forvridd gjerde",
  "block.minecraft.warped_fence_gate": "Forvridd grind",
  "block.minecraft.warped_fungus": "Forvridd sopp",
  "block.minecraft.warped_hanging_sign": "Hengende forvridd skilt",
  "block.minecraft.warped_hyphae": "Forvridd hyfe",
  "block.minecraft.warped_nylium": "Forvridd nylium",
  "block.minecraft.warped_planks": "Forvridde planker",
  "block.minecraft.warped_pressure_plate": "Forvridd trykkplate",
  "block.minecraft.warped_roots": "Forvridde røtter",
  "block.minecraft.warped_shelf": "Forvridd hylle",
  "block.minecraft.warped_sign": "Forvridd skilt",
  "block.minecraft.warped_slab": "Forvridd helle",
  "block.minecraft.warped_stairs": "Forvridde trapper",
  "block.minecraft.warped_stem": "Forvridd stilk",
  "block.minecraft.warped_trapdoor": "Forvridd fallem",
  "block.minecraft.warped_wall_hanging_sign": "Vegghengende forvridd skilt",
  "block.minecraft.warped_wall_sign": "Forvridd veggskilt",
  "block.minecraft.warped_wart_block": "Forvridd vorteblokk",
  "block.minecraft.water": "Vann",
  "block.minecraft.water_cauldron": "Gryte med vann",
  "block.minecraft.waxed_chiseled_copper": "Vokset uthugget kobber",
  "block.minecraft.waxed_copper_bars": "Vokset kobbergitter",
  "block.minecraft.waxed_copper_block": "Blokk av vokset kobber",
  "block.minecraft.waxed_copper_bulb": "Vokset kobberpære",
  "block.minecraft.waxed_copper_chain": "Vokset kobberkjetting",
  "block.minecraft.waxed_copper_chest": "Vokset kobberkiste",
  "block.minecraft.waxed_copper_door": "Vokset kobberdør",
  "block.minecraft.waxed_copper_golem_statue": "Vokset kobbergubbestatue",
  "block.minecraft.waxed_copper_grate": "Vokset kobberrist",
  "block.minecraft.waxed_copper_lantern": "Vokset kobberlykt",
  "block.minecraft.waxed_copper_trapdoor": "Vokset kobberfallem",
  "block.minecraft.waxed_cut_copper": "Vokset skåret kobber",
  "block.minecraft.waxed_cut_copper_slab": "Helle av vokset skåret kobber",
  "block.minecraft.waxed_cut_copper_stairs": "Trapp av vokset skåret kobber",
  "block.minecraft.waxed_exposed_chiseled_copper": "Vokset utsatt uthugget kobber",
  "block.minecraft.waxed_exposed_copper": "Vokset utsatt kobber",
  "block.minecraft.waxed_exposed_copper_bars": "Vokset utsatt kobbergitter",
  "block.minecraft.waxed_exposed_copper_bulb": "Vokset utsatt kobberpære",
  "block.minecraft.waxed_exposed_copper_chain": "Vokset utsatt kobberkjetting",
  "block.minecraft.waxed_exposed_copper_chest": "Vokset utsatt kobberkiste",
  "block.minecraft.waxed_exposed_copper_door": "Vokset utsatt kobberdør",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Vokset utsatt kobbergubbestatue",
  "block.minecraft.waxed_exposed_copper_grate": "Vokset utsatt kobberrist",
  "block.minecraft.waxed_exposed_copper_lantern": "Vokset utsatt kobberlykt",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Vokset utsatt kobberfallem",
  "block.minecraft.waxed_exposed_cut_copper": "Vokset utsatt skåret kobber",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Helle av vokset utsatt skåret kobber",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Trapp av vokset utsatt skåret kobber",
  "block.minecraft.waxed_exposed_lightning_rod": "Vokset utsatt lynavleder",
  "block.minecraft.waxed_lightning_rod": "Vokset lynavleder",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Vokset irret uthugget kobber",
  "block.minecraft.waxed_oxidized_copper": "Vokset irret kobber",
  "block.minecraft.waxed_oxidized_copper_bars": "Vokset irret kobbergitter",
  "block.minecraft.waxed_oxidized_copper_bulb": "Vokset irret kobberpære",
  "block.minecraft.waxed_oxidized_copper_chain": "Vokset irret kobberkjetting",
  "block.minecraft.waxed_oxidized_copper_chest": "Vokset irret kobberkiste",
  "block.minecraft.waxed_oxidized_copper_door": "Vokset irret kobberdør",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Vokset irret kobbergubbestatue",
  "block.minecraft.waxed_oxidized_copper_grate": "Vokset irret kobberrist",
  "block.minecraft.waxed_oxidized_copper_lantern": "Vokset irret kobberlykt",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Vokset irret kobberfallem",
  "block.minecraft.waxed_oxidized_cut_copper": "Vokset irret skåret kobber",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Helle av vokset irret skåret kobber",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Trapp av vokset irret skåret kobber",
  "block.minecraft.waxed_oxidized_lightning_rod": "Vokset irret lynavleder",
  "block.minecraft.waxed_weathered_chiseled_copper": "Vokset værbitt uthugget kobber",
  "block.minecraft.waxed_weathered_copper": "Vokset værbitt kobber",
  "block.minecraft.waxed_weathered_copper_bars": "Vokset værbitt kobbergitter",
  "block.minecraft.waxed_weathered_copper_bulb": "Vokset værbitt kobberpære",
  "block.minecraft.waxed_weathered_copper_chain": "Vokset værbitt kobberkjetting",
  "block.minecraft.waxed_weathered_copper_chest": "Vokset værbitt kobberkiste",
  "block.minecraft.waxed_weathered_copper_door": "Vokset værbitt kobberdør",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Vokset værbitt kobbergubbestatue",
  "block.minecraft.waxed_weathered_copper_grate": "Vokset værbitt kobberrist",
  "block.minecraft.waxed_weathered_copper_lantern": "Vokset værbitt kobberlykt",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Vokset værbitt kobberfallem",
  "block.minecraft.waxed_weathered_cut_copper": "Vokset værbitt skåret kobber",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Helle av vokset værbitt skåret kobber",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Trapp av vokset værbitt skåret kobber",
  "block.minecraft.waxed_weathered_lightning_rod": "Vokset værbitt lynavleder",
  "block.minecraft.weathered_chiseled_copper": "Værbitt uthugget kobber",
  "block.minecraft.weathered_copper": "Værbitt kobber",
  "block.minecraft.weathered_copper_bars": "Værbitt kobbergitter",
  "block.minecraft.weathered_copper_bulb": "Værbitt kobberpære",
  "block.minecraft.weathered_copper_chain": "Værbitt kobberkjetting",
  "block.minecraft.weathered_copper_chest": "Værbitt kobberkiste",
  "block.minecraft.weathered_copper_door": "Værbitt kobberdør",
  "block.minecraft.weathered_copper_golem_statue": "Værbitt kobbergubbestatue",
  "block.minecraft.weathered_copper_grate": "Værbitt kobberrist",
  "block.minecraft.weathered_copper_lantern": "Værbitt kobberlykt",
  "block.minecraft.weathered_copper_trapdoor": "Værbitt kobberfallem",
  "block.minecraft.weathered_cut_copper": "Værbitt skåret kobber",
  "block.minecraft.weathered_cut_copper_slab": "Helle av værbitt skåret kobber",
  "block.minecraft.weathered_cut_copper_stairs": "Trapp av værbitt skåret kobber",
  "block.minecraft.weathered_lightning_rod": "Værbitt lynavleder",
  "block.minecraft.weeping_vines": "Slengvin",
  "block.minecraft.weeping_vines_plant": "Slengvin",
  "block.minecraft.wet_sponge": "Våt svamp",
  "block.minecraft.wheat": "Hveteavlinger",
  "block.minecraft.white_banner": "Hvitt banner",
  "block.minecraft.white_bed": "Hvit seng",
  "block.minecraft.white_candle": "Hvitt vokslys",
  "block.minecraft.white_candle_cake": "Kake med hvitt lys",
  "block.minecraft.white_carpet": "Hvitt teppe",
  "block.minecraft.white_concrete": "Hvit betong",
  "block.minecraft.white_concrete_powder": "Hvit sement",
  "block.minecraft.white_glazed_terracotta": "Hvit glasert terrakotta",
  "block.minecraft.white_shulker_box": "Hvit shulkerboks",
  "block.minecraft.white_stained_glass": "Hvitt farget glass",
  "block.minecraft.white_stained_glass_pane": "Hvit farget glassrute",
  "block.minecraft.white_terracotta": "Hvit terrakotta",
  "block.minecraft.white_tulip": "Hvit tulipan",
  "block.minecraft.white_wool": "Hvit ull",
  "block.minecraft.wildflowers": "Markblomster",
  "block.minecraft.wither_rose": "Witherrose",
  "block.minecraft.wither_skeleton_skull": "Witherskjelettskalle",
  "block.minecraft.wither_skeleton_wall_skull": "Witherskjelettveggskalle",
  "block.minecraft.yellow_banner": "Gult banner",
  "block.minecraft.yellow_bed": "Gul seng",
  "block.minecraft.yellow_candle": "Gult vokslys",
  "block.minecraft.yellow_candle_cake": "Kake med gult lys",
  "block.minecraft.yellow_carpet": "Gult teppe",
  "block.minecraft.yellow_concrete": "Gul betong",
  "block.minecraft.yellow_concrete_powder": "Gul sement",
  "block.minecraft.yellow_glazed_terracotta": "Gul glasert terrakotta",
  "block.minecraft.yellow_shulker_box": "Gul shulkerboks",
  "block.minecraft.yellow_stained_glass": "Gult farget glass",
  "block.minecraft.yellow_stained_glass_pane": "Gul farget glassrute",
  "block.minecraft.yellow_terracotta": "Gul terrakotta",
  "block.minecraft.yellow_wool": "Gul ull",
  "block.minecraft.zombie_head": "Zombiehode",
  "block.minecraft.zombie_wall_head": "Zombievegghode",
  "item.minecraft.acacia_boat": "Akasiebåt",
  "item.minecraft.acacia_chest_boat": "Akasiebåt med kiste",
  "item.minecraft.allay_spawn_egg": "Fremkallingsegg for hjelpeånd",
  "item.minecraft.amethyst_shard": "Ametystskår",
  "item.minecraft.angler_pottery_shard": "Potteskår med fiskestang",
  "item.minecraft.angler_pottery_sherd": "Potteskår med fiskestang",
  "item.minecraft.apple": "Eple",
  "item.minecraft.archer_pottery_shard": "Potteskår med pil og bue",
  "item.minecraft.archer_pottery_sherd": "Potteskår med pil og bue",
  "item.minecraft.armadillo_scute": "Beltedyrskjoldplate",
  "item.minecraft.armadillo_spawn_egg": "Fremkallingsegg for beltedyr",
  "item.minecraft.armor_stand": "Rustningsstativ",
  "item.minecraft.arms_up_pottery_shard": "Potteskår med armer i været",
  "item.minecraft.arms_up_pottery_sherd": "Potteskår med armer i været",
  "item.minecraft.arrow": "Pil",
  "item.minecraft.axolotl_bucket": "Axolotl i bøtte",
  "item.minecraft.axolotl_spawn_egg": "Fremkallingsegg for axolotl",
  "item.minecraft.baked_potato": "Bakt potet",
  "item.minecraft.bamboo_chest_raft": "Bambusflåte med kiste",
  "item.minecraft.bamboo_raft": "Bambusflåte",
  "item.minecraft.bat_spawn_egg": "Fremkallingsegg for flaggermus",
  "item.minecraft.bee_spawn_egg": "Fremkallingsegg for bie",
  "item.minecraft.beef": "Rå biff",
  "item.minecraft.beetroot": "Rødbete",
  "item.minecraft.beetroot_seeds": "Rødbetefrø",
  "item.minecraft.beetroot_soup": "Rødbetesuppe",
  "item.minecraft.birch_boat": "Bjørkebåt",
  "item.minecraft.birch_chest_boat": "Bjørkebåt med kiste",
  "item.minecraft.black_bundle": "Svart bunt",
  "item.minecraft.black_dye": "Svart fargestoff",
  "item.minecraft.black_harness": "Svart seletøy",
  "item.minecraft.blade_pottery_shard": "Potteskår med klinge",
  "item.minecraft.blade_pottery_sherd": "Potteskår med klinge",
  "item.minecraft.blaze_powder": "Flammepulver",
  "item.minecraft.blaze_rod": "Flammestang",
  "item.minecraft.blaze_spawn_egg": "Fremkallingsegg for flammeskrømt",
  "item.minecraft.blue_bundle": "Blå bunt",
  "item.minecraft.blue_dye": "Blått fargestoff",
  "item.minecraft.blue_egg": "Blått egg",
  "item.minecraft.blue_harness": "Blått seletøy",
  "item.minecraft.bogged_spawn_egg": "Framkallingsegg for myrrangel",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smimal",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Lynaktig rustningspryd",
  "item.minecraft.bone": "Bein",
  "item.minecraft.bone_meal": "Beinmel",
  "item.minecraft.book": "Bok",
  "item.minecraft.bordure_indented_banner_pattern": "Bord med tannsnitt-bannermønster",
  "item.minecraft.bow": "Bue",
  "item.minecraft.bowl": "Bolle",
  "item.minecraft.bread": "Brød",
  "item.minecraft.breeze_rod": "Vindstang",
  "item.minecraft.breeze_spawn_egg": "Fremkallingsegg for vindskrømt",
  "item.minecraft.brewer_pottery_shard": "Potteskår med brygg",
  "item.minecraft.brewer_pottery_sherd": "Potteskår med brygg",
  "item.minecraft.brewing_stand": "Bryggestativ",
  "item.minecraft.brick": "Teglstein",
  "item.minecraft.brown_bundle": "Brun bunt",
  "item.minecraft.brown_dye": "Brunt fargestoff",
  "item.minecraft.brown_egg": "Brunt egg",
  "item.minecraft.brown_harness": "Brunt seletøy",
  "item.minecraft.brush": "Børste",
  "item.minecraft.bucket": "Bøtte",
  "item.minecraft.bundle": "Bunt",
  "item.minecraft.bundle.empty": "Tom",
  "item.minecraft.bundle.empty.description": "Kan romme en blandet hop av gjenstander",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Potteskår med ild",
  "item.minecraft.burn_pottery_sherd": "Potteskår med ild",
  "item.minecraft.camel_husk_spawn_egg": "Fremkallingsegg for dromedarskrell",
  "item.minecraft.camel_spawn_egg": "Fremkallingsegg for dromedar",
  "item.minecraft.carrot": "Gulrot",
  "item.minecraft.carrot_on_a_stick": "Gulrot på stang",
  "item.minecraft.cat_spawn_egg": "Fremkallingsegg for katt",
  "item.minecraft.cauldron": "Gryte",
  "item.minecraft.cave_spider_spawn_egg": "Fremkallingsegg for huleedderkopp",
  "item.minecraft.chainmail_boots": "Brynjestøvler",
  "item.minecraft.chainmail_chestplate": "Ringbrynje",
  "item.minecraft.chainmail_helmet": "Brynjehette",
  "item.minecraft.chainmail_leggings": "Brynjehose",
  "item.minecraft.charcoal": "Trekull",
  "item.minecraft.cherry_boat": "Kirsebærtrebåt",
  "item.minecraft.cherry_chest_boat": "Kirsebærtrebåt med kiste",
  "item.minecraft.chest_minecart": "Gruvevogn med kiste",
  "item.minecraft.chicken": "Rå kylling",
  "item.minecraft.chicken_spawn_egg": "Fremkallingsegg for høne",
  "item.minecraft.chorus_fruit": "Refrengfrukt",
  "item.minecraft.clay_ball": "Leireball",
  "item.minecraft.clock": "Klokke",
  "item.minecraft.coal": "Kull",
  "item.minecraft.coast_armor_trim_smithing_template": "Smimal",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Forlist rustningspryd",
  "item.minecraft.cocoa_beans": "Kakaobønner",
  "item.minecraft.cod": "Rå torsk",
  "item.minecraft.cod_bucket": "Torskebøtte",
  "item.minecraft.cod_spawn_egg": "Fremkallingsegg for torsk",
  "item.minecraft.command_block_minecart": "Gruvevogn med kommandoblokk",
  "item.minecraft.compass": "Kompass",
  "item.minecraft.cooked_beef": "Stekt biff",
  "item.minecraft.cooked_chicken": "Stekt kylling",
  "item.minecraft.cooked_cod": "Stekt torsk",
  "item.minecraft.cooked_mutton": "Stekt fårekjøtt",
  "item.minecraft.cooked_porkchop": "Stekt svinekotelett",
  "item.minecraft.cooked_rabbit": "Stekt kanin",
  "item.minecraft.cooked_salmon": "Stekt laks",
  "item.minecraft.cookie": "Kjeks",
  "item.minecraft.copper_axe": "Kobberøks",
  "item.minecraft.copper_boots": "Kobberstøvler",
  "item.minecraft.copper_chestplate": "Kobberbrystplate",
  "item.minecraft.copper_golem_spawn_egg": "Fremkallingsegg for kobbergubbe",
  "item.minecraft.copper_helmet": "Kobberhjelm",
  "item.minecraft.copper_hoe": "Kobbergrev",
  "item.minecraft.copper_horse_armor": "Kobberhesterustning",
  "item.minecraft.copper_ingot": "Kobberbarre",
  "item.minecraft.copper_leggings": "Kobberbenplater",
  "item.minecraft.copper_nautilus_armor": "Kobberperlebåtrustning",
  "item.minecraft.copper_nugget": "Kobberklump",
  "item.minecraft.copper_pickaxe": "Kobberhakke",
  "item.minecraft.copper_shovel": "Kobberspade",
  "item.minecraft.copper_spear": "Kobberspyd",
  "item.minecraft.copper_sword": "Kobbersverd",
  "item.minecraft.cow_spawn_egg": "Fremkallingsegg for ku",
  "item.minecraft.creaking_spawn_egg": "Fremkallingsegg for knirkning",
  "item.minecraft.creeper_banner_pattern": "Bannermønster",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper-bannermønster",
  "item.minecraft.creeper_spawn_egg": "Fremkallingsegg for creeper",
  "item.minecraft.crossbow": "Armbrøst",
  "item.minecraft.crossbow.projectile": "Ladning:",
  "item.minecraft.crossbow.projectile.multiple": "Prosjektil: %s × %s",
  "item.minecraft.crossbow.projectile.single": "Prosjektil: %s",
  "item.minecraft.cyan_bundle": "Cyan bunt",
  "item.minecraft.cyan_dye": "Turkist fargestoff",
  "item.minecraft.cyan_harness": "Cyan seletøy",
  "item.minecraft.danger_pottery_shard": "Potteskår med fare",
  "item.minecraft.danger_pottery_sherd": "Potteskår med fare",
  "item.minecraft.dark_oak_boat": "Mørkeikebåt",
  "item.minecraft.dark_oak_chest_boat": "Mørkeikebåt med kiste",
  "item.minecraft.debug_stick": "Feilsøkingspinne",
  "item.minecraft.debug_stick.empty": "%s har ingen egenskaper",
  "item.minecraft.debug_stick.select": "valgte \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" til %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamantøks",
  "item.minecraft.diamond_boots": "Diamantstøvler",
  "item.minecraft.diamond_chestplate": "Diamantbrystplate",
  "item.minecraft.diamond_helmet": "Diamanthjelm",
  "item.minecraft.diamond_hoe": "Diamantgrev",
  "item.minecraft.diamond_horse_armor": "Diamanthesterustning",
  "item.minecraft.diamond_leggings": "Diamantbenplater",
  "item.minecraft.diamond_nautilus_armor": "Diamantperlebåtrustning",
  "item.minecraft.diamond_pickaxe": "Diamanthakke",
  "item.minecraft.diamond_shovel": "Diamantspade",
  "item.minecraft.diamond_spear": "Diamantspyd",
  "item.minecraft.diamond_sword": "Diamantsverd",
  "item.minecraft.disc_fragment_5": "Platefragment",
  "item.minecraft.disc_fragment_5.desc": "Musikkplate - 5",
  "item.minecraft.dolphin_spawn_egg": "Fremkallingsegg for delfin",
  "item.minecraft.donkey_spawn_egg": "Fremkallingsegg for esel",
  "item.minecraft.dragon_breath": "Dragens ånde",
  "item.minecraft.dried_kelp": "Tørket tare",
  "item.minecraft.drowned_spawn_egg": "Fremkallingsegg for draug",
  "item.minecraft.dune_armor_trim_smithing_template": "Smimal",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dynens rustningspryd",
  "item.minecraft.echo_shard": "Ekkoskår",
  "item.minecraft.egg": "Egg",
  "item.minecraft.elder_guardian_spawn_egg": "Fremkallingsegg for urvokter",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Fortryllet bok",
  "item.minecraft.enchanted_golden_apple": "Fortryllet gulleple",
  "item.minecraft.end_crystal": "End-krystall",
  "item.minecraft.ender_dragon_spawn_egg": "Fremkallingsegg for enderdrage",
  "item.minecraft.ender_eye": "Enderøye",
  "item.minecraft.ender_pearl": "Enderperle",
  "item.minecraft.enderman_spawn_egg": "Fremkallingsegg for endermann",
  "item.minecraft.endermite_spawn_egg": "Fremkallingsegg for endermidd",
  "item.minecraft.evoker_spawn_egg": "Fremkallingsegg for åndemaner",
  "item.minecraft.experience_bottle": "Fortryllelsesflaske",
  "item.minecraft.explorer_pottery_shard": "Potteskår med kart",
  "item.minecraft.explorer_pottery_sherd": "Potteskår med kart",
  "item.minecraft.eye_armor_trim_smithing_template": "Smimal",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Skarpsynt rustningspryd",
  "item.minecraft.feather": "Fjær",
  "item.minecraft.fermented_spider_eye": "Gjæret edderkoppøye",
  "item.minecraft.field_masoned_banner_pattern": "Murstein-bannermønster",
  "item.minecraft.filled_map": "Kart",
  "item.minecraft.fire_charge": "Ildladning",
  "item.minecraft.firework_rocket": "Fyrverkeri",
  "item.minecraft.firework_rocket.flight": "Flygevarighet:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Fyrverkeristjerne",
  "item.minecraft.firework_star.black": "Svart",
  "item.minecraft.firework_star.blue": "Blå",
  "item.minecraft.firework_star.brown": "Brun",
  "item.minecraft.firework_star.custom_color": "Tilpasset",
  "item.minecraft.firework_star.cyan": "Turkis",
  "item.minecraft.firework_star.fade_to": "Ton inn til",
  "item.minecraft.firework_star.flicker": "Glimt",
  "item.minecraft.firework_star.gray": "Grå",
  "item.minecraft.firework_star.green": "Grønn",
  "item.minecraft.firework_star.light_blue": "Lyseblå",
  "item.minecraft.firework_star.light_gray": "Lysegrå",
  "item.minecraft.firework_star.lime": "Limegrønn",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Oransje",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Lilla",
  "item.minecraft.firework_star.red": "Rød",
  "item.minecraft.firework_star.shape": "Ukjent form",
  "item.minecraft.firework_star.shape.burst": "Eksplosjon",
  "item.minecraft.firework_star.shape.creeper": "Creeper-formet",
  "item.minecraft.firework_star.shape.large_ball": "Stor kule",
  "item.minecraft.firework_star.shape.small_ball": "Liten kule",
  "item.minecraft.firework_star.shape.star": "Stjerneformet",
  "item.minecraft.firework_star.trail": "Spor",
  "item.minecraft.firework_star.white": "Hvit",
  "item.minecraft.firework_star.yellow": "Gul",
  "item.minecraft.fishing_rod": "Fiskestang",
  "item.minecraft.flint": "Flint",
  "item.minecraft.flint_and_steel": "Tennstål",
  "item.minecraft.flow_armor_trim_smithing_template": "Smimal",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Virvlende rustningspryd",
  "item.minecraft.flow_banner_pattern": "Bannermønster",
  "item.minecraft.flow_banner_pattern.desc": "Virvel",
  "item.minecraft.flow_banner_pattern.new": "Virvel-bannermønster",
  "item.minecraft.flow_pottery_sherd": "Potteskår med virvel",
  "item.minecraft.flower_banner_pattern": "Bannermønster",
  "item.minecraft.flower_banner_pattern.desc": "Blomst",
  "item.minecraft.flower_banner_pattern.new": "Blomst-bannermønster",
  "item.minecraft.flower_pot": "Blomsterpotte",
  "item.minecraft.fox_spawn_egg": "Fremkallingsegg for rev",
  "item.minecraft.friend_pottery_shard": "Potteskår med venn",
  "item.minecraft.friend_pottery_sherd": "Potteskår med venn",
  "item.minecraft.frog_spawn_egg": "Fremkallingsegg for frosk",
  "item.minecraft.furnace_minecart": "Dampdrevet gruvevogn",
  "item.minecraft.ghast_spawn_egg": "Fremkallingsegg for ghast",
  "item.minecraft.ghast_tear": "Ghasttåre",
  "item.minecraft.glass_bottle": "Glassflaske",
  "item.minecraft.glistering_melon_slice": "Glitrende melonbåt",
  "item.minecraft.globe_banner_pattern": "Bannermønster",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Globus-bannermønster",
  "item.minecraft.glow_berries": "Glødbær",
  "item.minecraft.glow_ink_sac": "Glosekk",
  "item.minecraft.glow_item_frame": "Gløderamme",
  "item.minecraft.glow_squid_spawn_egg": "Fremkallingsegg for glosprut",
  "item.minecraft.glowstone_dust": "Glødesteinspulver",
  "item.minecraft.goat_horn": "Bukkehorn",
  "item.minecraft.goat_spawn_egg": "Fremkallingsegg for geit",
  "item.minecraft.gold_ingot": "Gullbarre",
  "item.minecraft.gold_nugget": "Gullklump",
  "item.minecraft.golden_apple": "Gulleple",
  "item.minecraft.golden_axe": "Gulløks",
  "item.minecraft.golden_boots": "Gullstøvler",
  "item.minecraft.golden_carrot": "Gullrot",
  "item.minecraft.golden_chestplate": "Gullbrystplate",
  "item.minecraft.golden_helmet": "Gullhjelm",
  "item.minecraft.golden_hoe": "Gullgrev",
  "item.minecraft.golden_horse_armor": "Gullhesterustning",
  "item.minecraft.golden_leggings": "Gullbenplater",
  "item.minecraft.golden_nautilus_armor": "Gullperlebåtrustning",
  "item.minecraft.golden_pickaxe": "Gullhakke",
  "item.minecraft.golden_shovel": "Gullspade",
  "item.minecraft.golden_spear": "Gullspyd",
  "item.minecraft.golden_sword": "Gullsverd",
  "item.minecraft.gray_bundle": "Grå bunt",
  "item.minecraft.gray_dye": "Grått fargestoff",
  "item.minecraft.gray_harness": "Grått seletøy",
  "item.minecraft.green_bundle": "Grønn bunt",
  "item.minecraft.green_dye": "Grønt fargestoff",
  "item.minecraft.green_harness": "Grønt seletøy",
  "item.minecraft.guardian_spawn_egg": "Fremkallingsegg for vokter",
  "item.minecraft.gunpowder": "Krutt",
  "item.minecraft.guster_banner_pattern": "Bannermønster",
  "item.minecraft.guster_banner_pattern.desc": "Vindkaster",
  "item.minecraft.guster_banner_pattern.new": "Vindkaster-bannermønster",
  "item.minecraft.guster_pottery_sherd": "Potteskår med vindkaster",
  "item.minecraft.happy_ghast_spawn_egg": "Fremkallingsegg for lykkelig ghast",
  "item.minecraft.harness": "Seletøy",
  "item.minecraft.heart_of_the_sea": "Havets hjerte",
  "item.minecraft.heart_pottery_shard": "Potteskår med hjerte",
  "item.minecraft.heart_pottery_sherd": "Potteskår med hjerte",
  "item.minecraft.heartbreak_pottery_shard": "Potteskår med hjerteskjær",
  "item.minecraft.heartbreak_pottery_sherd": "Potteskår med hjerteskjær",
  "item.minecraft.hoglin_spawn_egg": "Fremkallingsegg for hoglin",
  "item.minecraft.honey_bottle": "Honning på flaske",
  "item.minecraft.honeycomb": "Bikake",
  "item.minecraft.hopper_minecart": "Gruvevogn med trakt",
  "item.minecraft.horse_spawn_egg": "Fremkallingsegg for hest",
  "item.minecraft.host_armor_trim_smithing_template": "Smimal",
  "item.minecraft.host_armor_trim_smithing_template.new": "Vertens rustningspryd",
  "item.minecraft.howl_pottery_shard": "Potteskår med ulv",
  "item.minecraft.howl_pottery_sherd": "Potteskår med ulv",
  "item.minecraft.husk_spawn_egg": "Fremkallingsegg for skrell",
  "item.minecraft.ink_sac": "Blekksekk",
  "item.minecraft.iron_axe": "Jernøks",
  "item.minecraft.iron_boots": "Jernstøvler",
  "item.minecraft.iron_chestplate": "Jernbrystplate",
  "item.minecraft.iron_golem_spawn_egg": "Fremkallingsegg for jernkjempe",
  "item.minecraft.iron_helmet": "Jernhjelm",
  "item.minecraft.iron_hoe": "Jerngrev",
  "item.minecraft.iron_horse_armor": "Jernhesterustning",
  "item.minecraft.iron_ingot": "Jernbarre",
  "item.minecraft.iron_leggings": "Jernbenplater",
  "item.minecraft.iron_nautilus_armor": "Jernperlebåtrustning",
  "item.minecraft.iron_nugget": "Jernklump",
  "item.minecraft.iron_pickaxe": "Jernhakke",
  "item.minecraft.iron_shovel": "Jernspade",
  "item.minecraft.iron_spear": "Jernspyd",
  "item.minecraft.iron_sword": "Jernsverd",
  "item.minecraft.item_frame": "Ramme",
  "item.minecraft.jungle_boat": "Jungeltrebåt",
  "item.minecraft.jungle_chest_boat": "Jungeltrebåt med kiste",
  "item.minecraft.knowledge_book": "Kunnskapsbok",
  "item.minecraft.lapis_lazuli": "Lasurstein",
  "item.minecraft.lava_bucket": "Lavabøtte",
  "item.minecraft.lead": "Tau",
  "item.minecraft.leather": "Lær",
  "item.minecraft.leather_boots": "Lærstøvler",
  "item.minecraft.leather_chestplate": "Lærtrøye",
  "item.minecraft.leather_helmet": "Lærhette",
  "item.minecraft.leather_horse_armor": "Lærhesterustning",
  "item.minecraft.leather_leggings": "Lærbukser",
  "item.minecraft.light_blue_bundle": "Lyseblå bunt",
  "item.minecraft.light_blue_dye": "Lyseblått fargestoff",
  "item.minecraft.light_blue_harness": "Lyseblått seletøy",
  "item.minecraft.light_gray_bundle": "Lysegrå bunt",
  "item.minecraft.light_gray_dye": "Lysegrått fargestoff",
  "item.minecraft.light_gray_harness": "Lysegrått seletøy",
  "item.minecraft.lime_bundle": "Limegrønn bunt",
  "item.minecraft.lime_dye": "Limegrønt fargestoff",
  "item.minecraft.lime_harness": "Limegrønt seletøy",
  "item.minecraft.lingering_potion": "Vedvarende eliksir",
  "item.minecraft.lingering_potion.effect.awkward": "Underlig vedvarende brygg",
  "item.minecraft.lingering_potion.effect.empty": "Vedvarende ubryggbart brygg",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Vedvarende ildmotstandsbrygg",
  "item.minecraft.lingering_potion.effect.harming": "Vedvarende skadebrygg",
  "item.minecraft.lingering_potion.effect.healing": "Vedvarende helbredelsesbrygg",
  "item.minecraft.lingering_potion.effect.infested": "Vedvarende befengningsbrygg",
  "item.minecraft.lingering_potion.effect.invisibility": "Vedvarende usynlighetsbrygg",
  "item.minecraft.lingering_potion.effect.leaping": "Vedvarende hoppebrygg",
  "item.minecraft.lingering_potion.effect.levitation": "Vedvarende levitasjonsbrygg",
  "item.minecraft.lingering_potion.effect.luck": "Vedvarende lykkebrygg",
  "item.minecraft.lingering_potion.effect.mundane": "Vanlig vedvarende brygg",
  "item.minecraft.lingering_potion.effect.night_vision": "Vedvarende nattsynsbrygg",
  "item.minecraft.lingering_potion.effect.oozing": "Vedvarende tytebrygg",
  "item.minecraft.lingering_potion.effect.poison": "Vedvarende giftbrygg",
  "item.minecraft.lingering_potion.effect.regeneration": "Vedvarende regenereringsbrygg",
  "item.minecraft.lingering_potion.effect.slow_falling": "Vedvarene fjærfallsbrygg",
  "item.minecraft.lingering_potion.effect.slowness": "Vedvarende treghetsbrygg",
  "item.minecraft.lingering_potion.effect.strength": "Vedvarende styrkebrygg",
  "item.minecraft.lingering_potion.effect.swiftness": "Vedvarende hurtighetsbrygg",
  "item.minecraft.lingering_potion.effect.thick": "Tjukt vedvarende brygg",
  "item.minecraft.lingering_potion.effect.turtle_master": "Skilpaddemesterens vedvarende brygg",
  "item.minecraft.lingering_potion.effect.water": "Vedvarende vannflaske",
  "item.minecraft.lingering_potion.effect.water_breathing": "Vedvarende vannpustingsbrygg",
  "item.minecraft.lingering_potion.effect.weakness": "Vedvarende svakhetsbrygg",
  "item.minecraft.lingering_potion.effect.weaving": "Vedvarende vevebrygg",
  "item.minecraft.lingering_potion.effect.wind_charged": "Vedvarende vindladningsbrygg",
  "item.minecraft.llama_spawn_egg": "Fremkallingsegg for lama",
  "item.minecraft.lodestone_compass": "Leidarsteinskompass",
  "item.minecraft.mace": "Stridsklubbe",
  "item.minecraft.magenta_bundle": "Magenta bunt",
  "item.minecraft.magenta_dye": "Magenta fargestoff",
  "item.minecraft.magenta_harness": "Magenta seletøy",
  "item.minecraft.magma_cream": "Magmakrem",
  "item.minecraft.magma_cube_spawn_egg": "Fremkallingsegg for magmakube",
  "item.minecraft.mangrove_boat": "Mangrovebåt",
  "item.minecraft.mangrove_chest_boat": "Mangrovebåt med kiste",
  "item.minecraft.map": "Blankt kart",
  "item.minecraft.melon_seeds": "Melonfrø",
  "item.minecraft.melon_slice": "Melonbåt",
  "item.minecraft.milk_bucket": "Melkebøtte",
  "item.minecraft.minecart": "Gruvevogn",
  "item.minecraft.miner_pottery_shard": "Potteskår med hakke",
  "item.minecraft.miner_pottery_sherd": "Potteskår med hakke",
  "item.minecraft.mojang_banner_pattern": "Bannermønster",
  "item.minecraft.mojang_banner_pattern.desc": "Dings",
  "item.minecraft.mojang_banner_pattern.new": "Dings-bannermønster",
  "item.minecraft.mooshroom_spawn_egg": "Fremkallingsegg for mooshroom",
  "item.minecraft.mourner_pottery_shard": "Potteskår med forvarer",
  "item.minecraft.mourner_pottery_sherd": "Potteskår med forvarer",
  "item.minecraft.mule_spawn_egg": "Fremkallingsegg for muldyr",
  "item.minecraft.mushroom_stew": "Soppstuing",
  "item.minecraft.music_disc_11": "Musikkplate",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Musikkplate",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Musikkplate",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Musikkplate",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Musikkplate",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Musikkplate",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Musikkplate",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Musikkplate",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Musikkplate",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Musikkplate",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Musikkplate",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Musikkplate",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Musikkplate",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Musikkplate",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Musikkplate",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Musikkplate",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Musikkplate",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Musikkplate",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Musikkplate",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Musikkplate",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Musikkplate",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rått fårekjøtt",
  "item.minecraft.name_tag": "Navnelapp",
  "item.minecraft.nautilus_shell": "Perlebåtskall",
  "item.minecraft.nautilus_spawn_egg": "Fremkallingsegg for perlebåt",
  "item.minecraft.nether_brick": "Netherteglstein",
  "item.minecraft.nether_star": "Netherstjerne",
  "item.minecraft.nether_wart": "Nethervorte",
  "item.minecraft.netherite_axe": "Netherittøks",
  "item.minecraft.netherite_boots": "Netherittstøvler",
  "item.minecraft.netherite_chestplate": "Netherittbrystplate",
  "item.minecraft.netherite_helmet": "Netheritthjelm",
  "item.minecraft.netherite_hoe": "Netherittgrev",
  "item.minecraft.netherite_horse_armor": "Netheritthesterustning",
  "item.minecraft.netherite_ingot": "Netherittbarre",
  "item.minecraft.netherite_leggings": "Netherittbenplater",
  "item.minecraft.netherite_nautilus_armor": "Netherittperlebåtrustning",
  "item.minecraft.netherite_pickaxe": "Netheritthakke",
  "item.minecraft.netherite_scrap": "Netherittskrap",
  "item.minecraft.netherite_shovel": "Netherittspade",
  "item.minecraft.netherite_spear": "Netherittspyd",
  "item.minecraft.netherite_sword": "Netherittsverd",
  "item.minecraft.netherite_upgrade_smithing_template": "Smimal",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherittoppgradering",
  "item.minecraft.oak_boat": "Eikebåt",
  "item.minecraft.oak_chest_boat": "Eikebåt med kiste",
  "item.minecraft.ocelot_spawn_egg": "Fremkallingsegg for ozelot",
  "item.minecraft.ominous_bottle": "Illevarslende flaske",
  "item.minecraft.ominous_trial_key": "Illevarslende prøvelsesnøkkel",
  "item.minecraft.orange_bundle": "Oransje bunt",
  "item.minecraft.orange_dye": "Oransje fargestoff",
  "item.minecraft.orange_harness": "Oransje seletøy",
  "item.minecraft.painting": "Maleri",
  "item.minecraft.pale_oak_boat": "Blekeikebåt",
  "item.minecraft.pale_oak_chest_boat": "Blekeikebåt med kiste",
  "item.minecraft.panda_spawn_egg": "Fremkallingsegg for panda",
  "item.minecraft.paper": "Papir",
  "item.minecraft.parched_spawn_egg": "Fremkallingsegg for knusktørket",
  "item.minecraft.parrot_spawn_egg": "Fremkallingsegg for papegøye",
  "item.minecraft.phantom_membrane": "Fantomhinne",
  "item.minecraft.phantom_spawn_egg": "Fremkallingsegg for fantom",
  "item.minecraft.pig_spawn_egg": "Fremkallingsegg for gris",
  "item.minecraft.piglin_banner_pattern": "Bannermønster",
  "item.minecraft.piglin_banner_pattern.desc": "Snute",
  "item.minecraft.piglin_banner_pattern.new": "Snute-bannermønster",
  "item.minecraft.piglin_brute_spawn_egg": "Fremkallingsegg for piglinbølle",
  "item.minecraft.piglin_spawn_egg": "Fremkallingsegg for piglin",
  "item.minecraft.pillager_spawn_egg": "Fremkallingsegg for plyndrer",
  "item.minecraft.pink_bundle": "Rosa bunt",
  "item.minecraft.pink_dye": "Rosa fargestoff",
  "item.minecraft.pink_harness": "Rosa seletøy",
  "item.minecraft.pitcher_plant": "Kanneplante",
  "item.minecraft.pitcher_pod": "Kanneplantebelg",
  "item.minecraft.plenty_pottery_shard": "Potteskår med rikdom",
  "item.minecraft.plenty_pottery_sherd": "Potteskår med rikdom",
  "item.minecraft.poisonous_potato": "Giftig potet",
  "item.minecraft.polar_bear_spawn_egg": "Fremkallingsegg for isbjørn",
  "item.minecraft.popped_chorus_fruit": "Ristet refrengfrukt",
  "item.minecraft.porkchop": "Rå svinekotelett",
  "item.minecraft.potato": "Potet",
  "item.minecraft.potion": "Brygg",
  "item.minecraft.potion.effect.awkward": "Basisbrygg",
  "item.minecraft.potion.effect.empty": "Ubryggelig brygg",
  "item.minecraft.potion.effect.fire_resistance": "Ildmotstandsbrygg",
  "item.minecraft.potion.effect.harming": "Skadebrygg",
  "item.minecraft.potion.effect.healing": "Helbredelsesbrygg",
  "item.minecraft.potion.effect.infested": "Befengningsbrygg",
  "item.minecraft.potion.effect.invisibility": "Usynlighetsbrygg",
  "item.minecraft.potion.effect.leaping": "Sprettebrygg",
  "item.minecraft.potion.effect.levitation": "Levitasjonsbrygg",
  "item.minecraft.potion.effect.luck": "Lykkebrygg",
  "item.minecraft.potion.effect.mundane": "Dagligdags brygg",
  "item.minecraft.potion.effect.night_vision": "Nattsynsbrygg",
  "item.minecraft.potion.effect.oozing": "Tytingsbrygg",
  "item.minecraft.potion.effect.poison": "Giftbrygg",
  "item.minecraft.potion.effect.regeneration": "Regenereringsbrygg",
  "item.minecraft.potion.effect.slow_falling": "Fjærfallsbrygg",
  "item.minecraft.potion.effect.slowness": "Treghetsbrygg",
  "item.minecraft.potion.effect.strength": "Styrkebrygg",
  "item.minecraft.potion.effect.swiftness": "Hurtighetsbrygg",
  "item.minecraft.potion.effect.thick": "Tykk brygg",
  "item.minecraft.potion.effect.turtle_master": "Skilpaddemesterens brygg",
  "item.minecraft.potion.effect.water": "Vannflaske",
  "item.minecraft.potion.effect.water_breathing": "Vannpustingsbrygg",
  "item.minecraft.potion.effect.weakness": "Svakhetsbrygg",
  "item.minecraft.potion.effect.weaving": "Vevingsbrygg",
  "item.minecraft.potion.effect.wind_charged": "Vindladningsbrygg",
  "item.minecraft.pottery_shard_archer": "Potteskår med pil og bue",
  "item.minecraft.pottery_shard_arms_up": "Potteskår med armer i været",
  "item.minecraft.pottery_shard_prize": "Potteskår med edelsten",
  "item.minecraft.pottery_shard_skull": "Potteskår med skalle",
  "item.minecraft.powder_snow_bucket": "Puddersnøbøtte",
  "item.minecraft.prismarine_crystals": "Prismarinkrystaller",
  "item.minecraft.prismarine_shard": "Prismarinskår",
  "item.minecraft.prize_pottery_shard": "Potteskår med edelsten",
  "item.minecraft.prize_pottery_sherd": "Potteskår med edelsten",
  "item.minecraft.pufferfish": "Kulefisk",
  "item.minecraft.pufferfish_bucket": "Kulefiskebøtte",
  "item.minecraft.pufferfish_spawn_egg": "Fremkallingsegg for kulefisk",
  "item.minecraft.pumpkin_pie": "Gresskarpai",
  "item.minecraft.pumpkin_seeds": "Gresskarfrø",
  "item.minecraft.purple_bundle": "Lilla bunt",
  "item.minecraft.purple_dye": "Lilla fargestoff",
  "item.minecraft.purple_harness": "Lilla seletøy",
  "item.minecraft.quartz": "Netherkvarts",
  "item.minecraft.rabbit": "Rå kanin",
  "item.minecraft.rabbit_foot": "Kaninlabb",
  "item.minecraft.rabbit_hide": "Kaninskinn",
  "item.minecraft.rabbit_spawn_egg": "Fremkallingsegg for kanin",
  "item.minecraft.rabbit_stew": "Kaninlapskaus",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smimal",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Oppdretterens rustningspryd",
  "item.minecraft.ravager_spawn_egg": "Fremkallingsegg for herjer",
  "item.minecraft.raw_copper": "Kobbermalm",
  "item.minecraft.raw_gold": "Gullmalm",
  "item.minecraft.raw_iron": "Jernmalm",
  "item.minecraft.recovery_compass": "Gjenfinnerkompass",
  "item.minecraft.red_bundle": "Rød bunt",
  "item.minecraft.red_dye": "Rødt fargestoff",
  "item.minecraft.red_harness": "Rødt seletøy",
  "item.minecraft.redstone": "Redstonepulver",
  "item.minecraft.resin_brick": "Kvaeteglstein",
  "item.minecraft.resin_clump": "Kvaeklump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smimal",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ribbeinsaktig rustningspryd",
  "item.minecraft.rotten_flesh": "Råttent kjøtt",
  "item.minecraft.saddle": "Sal",
  "item.minecraft.salmon": "Rå laks",
  "item.minecraft.salmon_bucket": "Laksebøtte",
  "item.minecraft.salmon_spawn_egg": "Fremkallingsegg for laks",
  "item.minecraft.scrape_pottery_sherd": "Potteskår med øks",
  "item.minecraft.scute": "Skjoldplate",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smimal",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Plyndret rustningspryd",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smimal",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Formgiverens rustningspryd",
  "item.minecraft.sheaf_pottery_shard": "Potteskår med nek",
  "item.minecraft.sheaf_pottery_sherd": "Potteskår med nek",
  "item.minecraft.shears": "Saks",
  "item.minecraft.sheep_spawn_egg": "Fremkallingsegg for sau",
  "item.minecraft.shelter_pottery_shard": "Potteskår med ly",
  "item.minecraft.shelter_pottery_sherd": "Potteskår med ly",
  "item.minecraft.shield": "Skjold",
  "item.minecraft.shield.black": "Svart skjold",
  "item.minecraft.shield.blue": "Blått skjold",
  "item.minecraft.shield.brown": "Brunt skjold",
  "item.minecraft.shield.cyan": "Turkist skjold",
  "item.minecraft.shield.gray": "Grått skjold",
  "item.minecraft.shield.green": "Grønt skjold",
  "item.minecraft.shield.light_blue": "Lyseblått skjold",
  "item.minecraft.shield.light_gray": "Lysegrått skjold",
  "item.minecraft.shield.lime": "Limegrønt skjold",
  "item.minecraft.shield.magenta": "Magenta skjold",
  "item.minecraft.shield.orange": "Oransje skjold",
  "item.minecraft.shield.pink": "Rosa skjold",
  "item.minecraft.shield.purple": "Lilla skjold",
  "item.minecraft.shield.red": "Rødt skjold",
  "item.minecraft.shield.white": "Hvitt skjold",
  "item.minecraft.shield.yellow": "Gult skjold",
  "item.minecraft.shulker_shell": "Shulkerskjell",
  "item.minecraft.shulker_spawn_egg": "Fremkallingsegg for shulker",
  "item.minecraft.sign": "Skilt",
  "item.minecraft.silence_armor_trim_smithing_template": "Smimal",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Stillhetens rustningspryd",
  "item.minecraft.silverfish_spawn_egg": "Fremkallingsegg for sølvkre",
  "item.minecraft.skeleton_horse_spawn_egg": "Fremkallingsegg for skjeletthest",
  "item.minecraft.skeleton_spawn_egg": "Fremkallingsegg for skjelett",
  "item.minecraft.skull_banner_pattern": "Bannermønster",
  "item.minecraft.skull_banner_pattern.desc": "Hodeskalle",
  "item.minecraft.skull_banner_pattern.new": "Hodeskalle-bannermønster",
  "item.minecraft.skull_pottery_shard": "Potteskår med skalle",
  "item.minecraft.skull_pottery_sherd": "Potteskår med skalle",
  "item.minecraft.slime_ball": "Slimball",
  "item.minecraft.slime_spawn_egg": "Fremkallingsegg for slim",
  "item.minecraft.smithing_template": "Smimal",
  "item.minecraft.smithing_template.applies_to": "Brukes på:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Legg til barre eller krystall",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rustning",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Legg til en rustningsdel",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Barrer & krystaller",
  "item.minecraft.smithing_template.ingredients": "Innhold:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Legg til netherittbarre",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantutstyr",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Legg til rustning, våpen eller redskap av diamant",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherittbarre",
  "item.minecraft.smithing_template.upgrade": "Oppgradering: ",
  "item.minecraft.sniffer_spawn_egg": "Fremkallingsegg for snufser",
  "item.minecraft.snort_pottery_shard": "Potteskår med snufser",
  "item.minecraft.snort_pottery_sherd": "Potteskår med snufser",
  "item.minecraft.snout_armor_trim_smithing_template": "Smimal",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snuteaktig rustningspryd",
  "item.minecraft.snow_golem_spawn_egg": "Fremkallingsegg for snømann",
  "item.minecraft.snowball": "Snøball",
  "item.minecraft.spectral_arrow": "Spektralpil",
  "item.minecraft.spider_eye": "Edderkoppøye",
  "item.minecraft.spider_spawn_egg": "Fremkallingsegg for edderkopp",
  "item.minecraft.spire_armor_trim_smithing_template": "Smimal",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spirens rustningspryd",
  "item.minecraft.splash_potion": "Kastbar brygg",
  "item.minecraft.splash_potion.effect.awkward": "Basiskastebrygg",
  "item.minecraft.splash_potion.effect.empty": "Ubryggbart kastebrygg",
  "item.minecraft.splash_potion.effect.fire_resistance": "Kastbart ildmotstandsbrygg",
  "item.minecraft.splash_potion.effect.harming": "Kastbart skadebrygg",
  "item.minecraft.splash_potion.effect.healing": "Kastbart helbredelsesbrygg",
  "item.minecraft.splash_potion.effect.infested": "Befengt kastebrygg",
  "item.minecraft.splash_potion.effect.invisibility": "Kastbart usynlighetsbrygg",
  "item.minecraft.splash_potion.effect.leaping": "Kastbart sprettebrygg",
  "item.minecraft.splash_potion.effect.levitation": "Kastbart levitasjonsbrygg",
  "item.minecraft.splash_potion.effect.luck": "Kastbart lykkebrygg",
  "item.minecraft.splash_potion.effect.mundane": "Dagligdags kastebrygg",
  "item.minecraft.splash_potion.effect.night_vision": "Kastbart nattsynsbrygg",
  "item.minecraft.splash_potion.effect.oozing": "Tytende kastebrygg",
  "item.minecraft.splash_potion.effect.poison": "Kastbart giftbrygg",
  "item.minecraft.splash_potion.effect.regeneration": "Kastbart regenereringsbrygg",
  "item.minecraft.splash_potion.effect.slow_falling": "Kastbart fjærfallsbrygg",
  "item.minecraft.splash_potion.effect.slowness": "Kastbart treghetsbrygg",
  "item.minecraft.splash_potion.effect.strength": "Kastbart styrkebrygg",
  "item.minecraft.splash_potion.effect.swiftness": "Kastbart hurtighetsbrygg",
  "item.minecraft.splash_potion.effect.thick": "Tjukt kastebrygg",
  "item.minecraft.splash_potion.effect.turtle_master": "Skilpaddemesterens kastebrygg",
  "item.minecraft.splash_potion.effect.water": "Kastbar vannflaske",
  "item.minecraft.splash_potion.effect.water_breathing": "Kastbart vannpustebrygg",
  "item.minecraft.splash_potion.effect.weakness": "Kastbart svakhetsbrygg",
  "item.minecraft.splash_potion.effect.weaving": "Kastbar vevebrygg",
  "item.minecraft.splash_potion.effect.wind_charged": "Kastbar vindladningsbrygg",
  "item.minecraft.spruce_boat": "Granbåt",
  "item.minecraft.spruce_chest_boat": "Granbåt med kiste",
  "item.minecraft.spyglass": "Kikkert",
  "item.minecraft.squid_spawn_egg": "Fremkallingsegg for blekksprut",
  "item.minecraft.stick": "Pinne",
  "item.minecraft.stone_axe": "Steinøks",
  "item.minecraft.stone_hoe": "Steingrev",
  "item.minecraft.stone_pickaxe": "Steinhakke",
  "item.minecraft.stone_shovel": "Steinspade",
  "item.minecraft.stone_spear": "Steinspyd",
  "item.minecraft.stone_sword": "Steinsverd",
  "item.minecraft.stray_spawn_egg": "Fremkallingsegg for vandrer",
  "item.minecraft.strider_spawn_egg": "Fremkmallingsegg for lavavandrer",
  "item.minecraft.string": "Tråd",
  "item.minecraft.sugar": "Sukker",
  "item.minecraft.suspicious_stew": "Mistenkelig stuing",
  "item.minecraft.sweet_berries": "Søtbær",
  "item.minecraft.tadpole_bucket": "Bøtte med rumpetroll",
  "item.minecraft.tadpole_spawn_egg": "Fremkallingsegg for rumpetroll",
  "item.minecraft.tide_armor_trim_smithing_template": "Smimal",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Fjærens rustningspryd",
  "item.minecraft.tipped_arrow": "Dyppet pil",
  "item.minecraft.tipped_arrow.effect.awkward": "Dyppet pil",
  "item.minecraft.tipped_arrow.effect.empty": "Uproduserbar dyppet pil",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Flammemotstandspil",
  "item.minecraft.tipped_arrow.effect.harming": "Skadepil",
  "item.minecraft.tipped_arrow.effect.healing": "Helbredelsespil",
  "item.minecraft.tipped_arrow.effect.infested": "Befengningspil",
  "item.minecraft.tipped_arrow.effect.invisibility": "Usynlighetspil",
  "item.minecraft.tipped_arrow.effect.leaping": "Sprettpil",
  "item.minecraft.tipped_arrow.effect.levitation": "Levitasjonspil",
  "item.minecraft.tipped_arrow.effect.luck": "Lykkepil",
  "item.minecraft.tipped_arrow.effect.mundane": "Dyppet pil",
  "item.minecraft.tipped_arrow.effect.night_vision": "Nattsynspil",
  "item.minecraft.tipped_arrow.effect.oozing": "Tytingspil",
  "item.minecraft.tipped_arrow.effect.poison": "Giftpil",
  "item.minecraft.tipped_arrow.effect.regeneration": "Regenereringspil",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Fjærfallspil",
  "item.minecraft.tipped_arrow.effect.slowness": "Treghetspil",
  "item.minecraft.tipped_arrow.effect.strength": "Styrkepil",
  "item.minecraft.tipped_arrow.effect.swiftness": "Hurtighetspil",
  "item.minecraft.tipped_arrow.effect.thick": "Dyppet pil",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Skilpaddemesterens pil",
  "item.minecraft.tipped_arrow.effect.water": "Sprutepil",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Undervannspustpil",
  "item.minecraft.tipped_arrow.effect.weakness": "Svekkelsespil",
  "item.minecraft.tipped_arrow.effect.weaving": "Vevingspil",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Vindladningspil",
  "item.minecraft.tnt_minecart": "Gruvevogn med TNT",
  "item.minecraft.torchflower_seeds": "Fakkelblomstfrø",
  "item.minecraft.totem_of_undying": "Udødelighetstotem",
  "item.minecraft.trader_llama_spawn_egg": "Fremkallingsegg for handelslama",
  "item.minecraft.trial_key": "Prøvelsesnøkkel",
  "item.minecraft.trident": "Trefork",
  "item.minecraft.tropical_fish": "Sydhavsfisk",
  "item.minecraft.tropical_fish_bucket": "Sydhavsfiskebøtte",
  "item.minecraft.tropical_fish_spawn_egg": "Fremkallingsegg for sydhavsfisk",
  "item.minecraft.turtle_helmet": "Skilpaddeskall",
  "item.minecraft.turtle_scute": "Skilpaddeskjoldplate",
  "item.minecraft.turtle_spawn_egg": "Fremkallingsegg for skilpadde",
  "item.minecraft.vex_armor_trim_smithing_template": "Smimal",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Plageåndens rustningspryd",
  "item.minecraft.vex_spawn_egg": "Fremkallingsegg for plageånd",
  "item.minecraft.villager_spawn_egg": "Fremkallingsegg for bygding",
  "item.minecraft.vindicator_spawn_egg": "Fremkallingsegg for forsvarer",
  "item.minecraft.wandering_trader_spawn_egg": "Fremkallingsegg for vandrehandler",
  "item.minecraft.ward_armor_trim_smithing_template": "Smimal",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Forvart rustningspryd",
  "item.minecraft.warden_spawn_egg": "Fremkallingsegg for forvarer",
  "item.minecraft.warped_fungus_on_a_stick": "Forvridd sopp på stang",
  "item.minecraft.water_bucket": "Vannbøtte",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smimal",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Veiviserens rustningspryd",
  "item.minecraft.wheat": "Hvete",
  "item.minecraft.wheat_seeds": "Hvetefrø",
  "item.minecraft.white_bundle": "Hvit bunt",
  "item.minecraft.white_dye": "Hvitt fargestoff",
  "item.minecraft.white_harness": "Hvitt seletøy",
  "item.minecraft.wild_armor_trim_smithing_template": "Smimal",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Vill rustningspryd",
  "item.minecraft.wind_charge": "Vindladning",
  "item.minecraft.witch_spawn_egg": "Fremkallingsegg for heks",
  "item.minecraft.wither_skeleton_spawn_egg": "Fremkallingsegg for witherskjelett",
  "item.minecraft.wither_spawn_egg": "Fremkallingsegg for wither",
  "item.minecraft.wolf_armor": "Ulverustning",
  "item.minecraft.wolf_spawn_egg": "Fremkallingsegg for ulv",
  "item.minecraft.wooden_axe": "Treøks",
  "item.minecraft.wooden_hoe": "Tregrev",
  "item.minecraft.wooden_pickaxe": "Trehakke",
  "item.minecraft.wooden_shovel": "Trespade",
  "item.minecraft.wooden_spear": "Trespyd",
  "item.minecraft.wooden_sword": "Tresverd",
  "item.minecraft.writable_book": "Bok og fjærpenn",
  "item.minecraft.written_book": "Skrevet bok",
  "item.minecraft.yellow_bundle": "Gul bunt",
  "item.minecraft.yellow_dye": "Gult fargestoff",
  "item.minecraft.yellow_harness": "Gult seletøy",
  "item.minecraft.zoglin_spawn_egg": "Fremkallingsegg for zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Fremkallingsegg for zombiehest",
  "item.minecraft.zombie_nautilus_spawn_egg": "Fremkallingsegg for zombieperlebåt",
  "item.minecraft.zombie_spawn_egg": "Fremkallingsegg for zombie",
  "item.minecraft.zombie_villager_spawn_egg": "Fremkallingsegg for zombiebygding",
  "item.minecraft.zombified_piglin_spawn_egg": "Fremkallingsegg for zombiepiglin"
}
export const no_no = items; 
